import React, {
  Fragment,
  useState,
  useEffect,
  useContext,
  useCallback,
  useRef,
  useMemo,
} from "react";
import { useResponsive } from "../hooks/useResponsive";
import Grid from "@mui/material/Unstable_Grid2";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import ApproveToolbox from "./ApproveToolbox";
import FilingMasterReferenceDocument from "./FilingMasterReferenceDocument";
import { DataTable } from "primereact/datatable";
import FilingMasterApprovalHistory from "./FilingMasterApprovalHistory";
import { Column } from "primereact/column";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { InputText } from "primereact/inputtext";
import { MultiSelect } from "primereact/multiselect";
import CustomDialog from "../common/CustomDialog";
import _ from "lodash";
import { capitalizeLeadingText } from "../../utils/textFormat";
import { useLocation } from "react-router-dom";
// import filingMasters from "../../data/filingMasters.json";
import AuthContext from "../../context/auth/AuthContext";
import FilingMasterContext from "../../context/filing-master/FilingMasterContext";
import ApproveFilingMaster from "./ApproveFilingMaster";
import FilingMasterWorkflowComments from "./ApprovalListComments";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import Box from "@mui/material/Box";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import ReactLoading from "react-loading";
import axios from "axios";
import InsertCommentRoundedIcon from "@mui/icons-material/InsertCommentRounded";
import { InputSwitch } from "primereact/inputswitch";
import { DateTime } from "luxon";
import SnippetFolderIcon from "@mui/icons-material/SnippetFolder";
import { Stack } from "@mui/material";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { OverlayPanel } from "primereact/overlaypanel";
import { CircularProgress } from "@mui/material";
import states from "../../data/StateLookup.json";
import { Dropdown } from "primereact/dropdown";
import ClientFilingMasterContext from "../../context/client-filing-master/ClientFilingMasterContext";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";

import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { tokens } from "../../theme/tokens";
import { useCommonDetailsContext } from "../../context/Common/common";
import { TrackNowButton } from "../ui/TrackNowButton";
import ClientTableFilter from "../customer/ClientTableFilter";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { TextField, InputAdornment, IconButton } from "@mui/material";
import { GoogleMaterialIcon } from "../ui/GoogleMaterialIcon";


const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const API_BASE_URL = process.env.REACT_APP_TRKNW_API_BASE_URL;

const ApprovalList = () => {
  const { publishedBranding } = useCommonDetailsContext();
  const tableHeaderColor = publishedBranding?.primaryColor || tokens.colors.connectedPurple;
  const containerBackgroundColor = tokens.colors.offWhite;
  const tableBackgroundColor = containerBackgroundColor;
  const { isMobile } = useResponsive();
  const enableForzen = !isMobile
  const [selectedFiling, setSelectedFiling] = useState([]);
  const [selectedRows, setSelectedRows] = useState(null);
  const [data, setData] = useState([]);
  const [initialData, setInitialData] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [pendingTableData, setPendingTableData] = useState([]);
  const [completedTableData, setCompletedTableData] = useState([]);
  const [pendingMyRequests, setPendingMyRequests] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [comments, setComments] = React.useState([]);
  const [stateArray, setStateArray] = useState([]);
  const [isClearIcon, setIsClearIcon] = useState(false);
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const [activeFilters, setActiveFilters] = useState([]);
  const [categoryList, setCategoryList] = useState([]);

  const [lazyLoading, setLazyLoading] = useState(false);
  const [refreshRecordList, setRefreshRecordList] = useState(false);
  const [refreshDetails, setRefreshDetails] = useState(null);
  const [recordsInView, setRecordsInView] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isFilterChange, setIsFilterChange] = useState([]);
  const [sortingData, setSortingData] = useState({
    sortBy: "",
    sortOrder: "",
  });
  const [commentActivityHistory, setCommentActivityHistory] = React.useState([]);
  const overlayRefs = useRef({});
  const lazyLoadInFlightRef = useRef(false);
  const pendingTableDataRef = useRef([]);
  const completedTableDataRef = useRef([]);
  const recordsInViewRef = useRef(0);
  const lastFilterSignatureRef = useRef("");

  const setRecordsInViewSafe = (nextValue) => {
    setRecordsInView((old) => {
      const next = typeof nextValue === "function" ? nextValue(old) : nextValue;
      recordsInViewRef.current = next;
      return next;
    });
  };

  const [federalFilterSelectedValues, setFederalFilterSelectedValues] =
    React.useState({
      federalCategories: [],
    });
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    approverName: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    filingName: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    // filingDescription: { value: null, matchMode: FilterMatchMode.CONTAINS },
    filingFrequency: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    // dueDayofFrequency: { value: null, matchMode: FilterMatchMode.IN },
    stateInfo: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    stateList: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.IN }],
    },
    workflowStatus: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    ruleInfo: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    required: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    federalCategories: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.IN }],
    },
    stateCategories: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.IN }],
    },
    // jsidept: { value: null, matchMode: FilterMatchMode.CONTAINS },
    jsicontactName: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    // jsicontactEmail: { value: null, matchMode: FilterMatchMode.CONTAINS },
    juristiction: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.IN }],
    },
  });
  const getFilingCategories = (filingMaster) => {
    return _.map(filingMaster.businessCategory, "businessCategoryName").join(
      ", "
    );
  };
  const filingMasterContext = useContext(FilingMasterContext);
  const {
    getFilingMasterApprovals,
    setFilingMasterApprovalsCompleted,
    filingMasterApprovalsCompleted,
    setFilingMasterApprovalsPending,
    filingMasterApprovals,
    filingMasterLoaded,
    getFilingMasterWorkflowComments,
    getBusinessCategories,
  } = filingMasterContext;

  const authContext = useContext(AuthContext);
  const { roleType, authId, authUser, toLocalDateTime } = authContext;
  // const data = filingMasterApprovals;
  // const [visibleApps, setVisibleApps] = useState(props.projects);
  const [showFilter, setShowFilter] = useState(false);
  const [showComments, setShowComments] = useState(false);
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [jurisdiction, setJurisdiction] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [clients, setClients] = useState([]);
  const [viewAll, setViewAll] = useState(true);
  const [value, setValue] = React.useState("1");
  const [expandedRows, setExpandedRows] = useState(null);
  const [filingPeriodTable, setFilingPeriodTable] = useState([]);
  const [attachments, setAttachments] = React.useState([]);
  const [showAttachments, setShowAttachments] = useState(false);
  const [showHistory, setShowHistory] = useState(false);
  const [activityHistory, setActivityHistory] = React.useState([]);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [yearsList, setYearsList] = useState([]);
  const [selectedYear, setSelectedYear] = useState("");
  const clientFilingMasterContext = useContext(ClientFilingMasterContext);
  const { fetchConfigurations } = clientFilingMasterContext;

  const pendingFilterColumns = [
    "filingName",
    "approverName",
    "filingFrequency",
    "stateList",
    "ruleInfo",
    "required",
    "federalCategories",
    "stateCategories",
    "jsicontactName",
    "juristiction",
  ];

  const completedFilterColumns = [
    "filingName",
    "filingFrequency",
    "workflowStatus",
    "stateList",
    "ruleInfo",
    "required",
    "federalCategories",
    "stateCategories",
    "jsicontactName",
    "juristiction",
  ];

  const closeFilter = () => {
    // console.log("Toggling Show Filter", showFilter);
    setShowFilter(() => false);
  };

  function handleViewAllClick() {
    setViewAll(true);
  }

  function handlePaginationClick() {
    setViewAll(false);
  }

  const toLocalDate = (date) => {
    if (date) {
      const options = { day: "2-digit", month: "short", year: "numeric" };
      let stringDate = new Date(date).toLocaleDateString("en-US", options);

      const _date = DateTime.fromFormat(stringDate, "MMM dd, yyyy").toFormat(
        "dd-MMM-yyyy "
      );
      // // console.log("@@@ LocalllTime:", _date);

      return _date;
    } else return "";
  };

  const newBusinessCategory = (oldBC, newBC) => {
    let BC =
      oldBC.length > 0 ? oldBC.map((ele) => ele.businessCategoryName) : [];
    let changedBC = newBC.map((ele) => ele.businessCategoryName);
    // console.log("newBusinessCategory", BC, changedBC);
    return {
      field: "Business Category",
      old: BC.reduce((acc, item) => acc + (acc === "" ? "" : " , ") + item, ""),
      new: changedBC.reduce(
        (acc, item) => acc + (acc === "" ? "" : " , ") + item,
        ""
      ),
    };
  };

  const getModified = async () => {
    let modefiedSel = await Promise.all(
      selectedFiling.map(async (ele) => {
        let modified = await fetchFilingMasterPendingHistory(ele.draftId);
        if (modified.length > 0) {
          let activity = modified.map((ele) => {
            let changed = [];
            if (ele.process === "Modified") {
              let keys = Object.keys(ele);
              keys.forEach((key) => {
                const capitalized = key.charAt(0).toUpperCase() + key.slice(1);
                if (
                  key === "businessCategory" &&
                  ele.newBusinessCategory !== null &&
                  ele.newBusinessCategory.length > 0
                ) {
                  let oldBC = ele.businessCategory !== null ? ele.businessCategory : [];
                  let isSame = _.isEqual(oldBC, ele.newBusinessCategory);
                  if (!isSame) {
                    changed.push(newBusinessCategory(oldBC, ele.newBusinessCategory));
                  }
                }
                else if (
                  key === "filingPeriods" &&
                  ele.newFilingPeriods !== null &&
                  ele.newFilingPeriods.length > 0
                ) {

                  // //Logics for not checking years -- Start
                  // let filingPeriods = ele.filingPeriods ? [...ele.filingPeriods] : [];
                  // let newFilingPeriods = [...ele.newFilingPeriods];


                  // // Sort both arrays by StartDate in descending order
                  // filingPeriods.sort((a, b) => new Date(b.StartDate) - new Date(a.StartDate));
                  // newFilingPeriods.sort((a, b) => new Date(b.StartDate) - new Date(a.StartDate));


                  // // Step 1: Check for exact StartDate (year, month, day match)
                  // let exactMatchFilingPeriods = filingPeriods.filter(fp =>
                  //   newFilingPeriods.some(nfp => new Date(fp.StartDate).getTime() === new Date(nfp.StartDate).getTime())
                  // );

                  // let exactMatchNewFilingPeriods = newFilingPeriods.filter(nfp =>
                  //   filingPeriods.some(fp => new Date(fp.StartDate).getTime() === new Date(nfp.StartDate).getTime())
                  // );

                  // // Step 2: If no exact match, check for month and day match (ignoring year)
                  // if (exactMatchFilingPeriods.length === 0) {
                  //   exactMatchFilingPeriods = filingPeriods.filter(fp =>
                  //     newFilingPeriods.some(nfp => {
                  //       let fpDate = new Date(fp.StartDate);
                  //       let nfpDate = new Date(nfp.StartDate);
                  //       return fpDate.getMonth() === nfpDate.getMonth() && fpDate.getDate() === nfpDate.getDate();
                  //     })
                  //   );

                  //   exactMatchNewFilingPeriods = newFilingPeriods.filter(nfp =>
                  //     filingPeriods.some(fp => {
                  //       let fpDate = new Date(fp.StartDate);
                  //       let nfpDate = new Date(nfp.StartDate);
                  //       return fpDate.getMonth() === nfpDate.getMonth() && fpDate.getDate() === nfpDate.getDate();
                  //     })
                  //   );
                  // }

                  // // Fill missing entries in newFilingPeriods with "Not modified"
                  // for (let i = exactMatchFilingPeriods.length; i > exactMatchNewFilingPeriods.length; i--) {
                  //   exactMatchNewFilingPeriods.push({ dueDate: "Not modified" });
                  // }

                  // // Construct changedData entry for Due Date
                  // changed.push({
                  //   field: "Due Date",
                  //   old: exactMatchFilingPeriods.map((periods) => toLocalDate(periods.dueDate)),
                  //   new: exactMatchNewFilingPeriods.map((periods) =>
                  //     periods.dueDate !== "Not modified" ? toLocalDate(periods.dueDate) : "Not modified"
                  //   ),
                  // });
                  // //Logics for not checking years -- END

                  if (ele.filingPeriods === null) {
                    let filingPeriods = [];
                    let newFilingPeriods = ele.newFilingPeriods.sort(function (
                      a,
                      b
                    ) {
                      return new Date(b.StartDate) - new Date(a.StartDate);
                    });
                    // console.log(
                    //   "filingPeriods newFilingPeriods",
                    //   filingPeriods,
                    //   newFilingPeriods
                    // );
                    changed.push({
                      field: "Due Date",
                      old: filingPeriods.map((periods) =>
                        toLocalDate(periods.dueDate)
                      ),
                      new: newFilingPeriods.map((periods) =>
                        toLocalDate(periods.dueDate)
                      ),
                    });
                  } else {
                    let isSame = _.isEqual(
                      ele.filingPeriods,
                      ele.newFilingPeriods
                    );
                    // console.log("filingPeriods isSame", isSame);
                    if (!isSame) {
                      let filingPeriods = ele.filingPeriods.sort(function (
                        a,
                        b
                      ) {
                        return new Date(b.StartDate) - new Date(a.StartDate);
                      });
                      let newFilingPeriods = ele.newFilingPeriods.sort(
                        function (a, b) {
                          return new Date(b.StartDate) - new Date(a.StartDate);
                        }
                      );
                      // console.log(
                      //   "filingPeriods newFilingPeriods",
                      //   filingPeriods,
                      //   newFilingPeriods
                      // );
                      // let oldFP = [];
                      // let newFP = [];
                      // filingPeriods.forEach((periods, i) => {
                      //   if (
                      //     filingPeriods[i].StartDate ===
                      //       newFilingPeriods[i].StartDate &&
                      //     !_.isEqual(filingPeriods[i], newFilingPeriods[i])
                      //   ) {
                      //     oldFP.push(filingPeriods[i]);
                      //     newFP.push(newFilingPeriods[i]);
                      //   }
                      // });
                      // console.log("filingPeriods oldFP", oldFP, newFP);
                      changed.push({
                        field: "Due Date",
                        old: filingPeriods.map((periods) =>
                          toLocalDate(periods.dueDate)
                        ),
                        new: newFilingPeriods.map((periods) =>
                          toLocalDate(periods.dueDate)
                        ),
                      });
                    }
                  }
                }

                else if (
                  key === "filingAttachments" &&
                  (ele.filingAttachments !== null || ele.newFilingAttachments !== null)
                ) {
                  let isSame = _.isEqual(ele.filingAttachments, ele.newFilingAttachments);
                  if (!isSame) {
                    let filingAttachments = ele.filingAttachments !== null ? ele.filingAttachments : [];
                    let newFilingAttachments =
                      ele.newFilingAttachments !== null ? ele.newFilingAttachments : [];

                    changed.push({
                      field: "Attachments",
                      old: filingAttachments,
                      new: newFilingAttachments,
                      draftId: ele.newDraftId,
                    });
                  }
                } else if (
                  ele[`new${capitalized}`] !== undefined &&
                  ele[key] !== ele[`new${capitalized}`] &&
                  key !== "draftId" &&
                  key !== "filingPeriods" &&
                  key !== "filingAttachments" &&
                  key !== "businessCategory"
                ) {
                  changed.push({
                    field: key,
                    old: ele[key],
                    new: ele[`new${capitalized}`],
                  });
                }
              });
            }

            if (changed.length > 0) {
              ele.changedData = changed;
            }
            return ele;
          });
          modified = activity;
        }

        ele.modified = modified;
        return ele;
      })
    );

    return modefiedSel;
  };




  const search = useRef();

  const applyGlobalFilter = () => {
    let _filters = { ...filters };
    if (isClearIcon) {
      search.current.value = "";
      _filters["global"].value = "";
      setIsClearIcon(false);
      onFilterChange({ filters: _filters });
    } else {
      _filters["global"].value = search.current.value;
      setIsClearIcon(true);
      onFilterChange({ filters: _filters });
    }
    setFilters(_filters);
  };

  const handleFilterClick = (event) => {
    setFilterAnchorEl(event.currentTarget);
  };

  const handleFilterClose = () => {
    setFilterAnchorEl(null);
  };

  const getFilterChipLabel = (field) => {
    const labels = {
      filingName: "Filing Name",
      approverName: "Approver Name",
      filingFrequency: "Filing Frequency",
      stateList: "State",
      ruleInfo: "Rule Info",
      required: "Required",
      federalCategories: "Who Must File Federal",
      stateCategories: "Who Must File In State",
      jsicontactName: "JSI Staff",
      juristiction: "Jurisdiction",
      workflowStatus: "Status",
    };

    if (labels[field]) {
      return labels[field];
    }

    return String(field || "")
      .replace(/[_-]+/g, " ")
      .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
      .replace(/\b\w/g, (char) => char.toUpperCase())
      .trim();
  };

  const approvalCategoryLookup = useMemo(() => {
    return Array.from(
      new Set(
        (categoryList || [])
          .map((item) =>
            typeof item === "string" ? item.trim() : String(item || "").trim()
          )
          .filter(Boolean)
      )
    ).sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
  }, [categoryList]);

  const normalizeRequiredFilterValue = (value) => {
    if (typeof value === "boolean") {
      return value;
    }

    if (typeof value === "string") {
      const lowered = value.trim().toLowerCase();
      if (lowered === "true") {
        return true;
      }
      if (lowered === "false") {
        return false;
      }
    }

    if (Array.isArray(value) && value.length > 0) {
      return normalizeRequiredFilterValue(value[0]);
    }

    return null;
  };

  const handleFilterApply = (filterConfig) => {
    console.log("Filter applied:", filterConfig);
    const allowedColumns =
      value === "1" ? pendingFilterColumns : completedFilterColumns;

    if (!allowedColumns.includes(filterConfig.field)) {
      return;
    }

    const normalizedRequiredValue =
      filterConfig.field === "required"
        ? normalizeRequiredFilterValue(filterConfig.value)
        : filterConfig.value;
    const normalizedMatchMode =
      filterConfig.field === "required"
        ? FilterMatchMode.EQUALS
        : filterConfig.matchMode;

    const newFilter = {
      ...filterConfig,
      id: Date.now(),
      label: getFilterChipLabel(filterConfig.field),
      matchMode: normalizedMatchMode,
      displayValue:
        filterConfig.field === "required"
          ? normalizedRequiredValue === null
            ? filterConfig.value
            : normalizedRequiredValue
              ? "True"
              : "False"
          : filterConfig.value,
    };
    setActiveFilters((prev) => [
      ...prev.filter((item) => item.field !== filterConfig.field),
      newFilter,
    ]);

    let _filters = { ...filters };
    if (filterConfig.field && _filters[filterConfig.field]) {
      _filters[filterConfig.field].constraints[0].value = normalizedRequiredValue;
      _filters[filterConfig.field].constraints[0].matchMode = normalizedMatchMode;
      setFilters(_filters);
      onFilterChange({ filters: _filters });
    }
  };

  const handleFilterClear = () => {
    setActiveFilters([]);
    setFilters({
      ...filters,
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    setFederalFilterSelectedValues([]);
    setRecordsInViewSafe(0);
    setIsLoading(true);
    setData([]);
    setInitialData([]);
    setPendingTableData([]);
    setCompletedTableData([]);
    setIsFilterChange([]);
    setSortingData({ sortBy: "", sortOrder: "" });
    setRefreshRecordList(true);
  };

  const removeFilter = (filterId) => {
    const filterToRemove = activeFilters.find(f => f.id === filterId);
    setActiveFilters(activeFilters.filter(f => f.id !== filterId));

    if (filterToRemove) {
      let _filters = { ...filters };
      if (filterToRemove.field && _filters[filterToRemove.field]) {
        _filters[filterToRemove.field].constraints[0].value = null;
        setFilters(_filters);
        onFilterChange({ filters: _filters });
      }
    }
  };

  const approveDraft = async () => {
    // console.log("Approving Draft", selectedFiling, "Role:", roleType);
    if (selectedFiling && selectedFiling.length === 0) {
      setAlertMessage("Please Select a Filing Master Record");
      setShowAlert(true);
      // } else if (selectedFiling.length !== 1 && authUser.roleName === "Admin") {
      //   setAlertMessage("Please select a single Filing Master Record");
      //   setShowAlert(true);
    } else if (selectedFiling && selectedFiling.length !== 0) {
      let modefiedSel = await getModified();
      // console.log("Approving getModified", modefiedSel);
      setShowFilter(() => true);
    }
    // else {
    //   setAlertMessage("Please Select a Filing Master Record");
    //   setShowAlert(true);
    // }
  };

  const fetchFilingMasterAttachments = async (draftId, filingId) => {
    // console.log("fetchFilingMasterAttachments props", draftId, value);
    try {
      let attachmentList;
      if (value === "2") {
        attachmentList = await axios.get(
          `${API_BASE_URL}/FilingMaster/FilingMasterAttachments/${filingId}`
        );
      } else {
        attachmentList = await axios.get(
          `${API_BASE_URL}/FilingMaster/FilingMasterDraftAttachments/${draftId}`
        );
      }
      let list = attachmentList.data.data.map((ele) => ({ ...ele, filingId }));
      setAttachments(() => list);
      // console.log("fetchFilingMasterAttachments res", attachmentList);
    } catch (error) {
      console.log("@@Error:", error);
    }
  };

  const closeAttachments = () => {
    // console.log("Toggling Show Filter", showAttachments);
    setShowAttachments(() => false);
  };
  const closeHistory = () => {
    // console.log("Toggling Show Filter", showHistory);
    setShowHistory(() => false);
  };

  const fetchFilingMasterHistory = async (selectedFiling) => {
    // console.log("fetchFilingMasterHistory props", "selectedFiling", selectedFiling, "filingId", selectedFiling.filingId, "workflowId", selectedFiling.workflowId);
    try {
      const history = await axios.get(
        `${API_BASE_URL}/FilingMaster/FilingMasterAudit?FilingId=${selectedFiling.filingId}`
      );
      setActivityHistory(() => history.data.data);
      // console.log("fetchFilingMasterHistory res", history);
    } catch (error) {
      console.log("@@Error:", error);
    }
    try {
      const history = await axios.get(
        `${API_BASE_URL}/FilingMaster/FilingMasterWorkflowCommentsaudit?WorkflowId=${selectedFiling.workflowId}`
      );
      setCommentActivityHistory(() => history.data.data);
    } catch (error) {
      console.log("@@Error:", error);
    }
  };

  const fetchFilingMasterPendingHistory = async (filingId) => {
    // console.log("fetchFilingMasterPendingHistory props", filingId);
    return new Promise(async (resolve, reject) => {
      try {
        const history = await axios.get(
          `${API_BASE_URL}/FilingMaster/MasterFilingPendingAudit?DraftId=${filingId}`
        );
        // console.log("fetchFilingMasterPendingHistory res", history);
        if (history.data) {
          resolve(history.data.data);
        }
        resolve([]);
      } catch (error) {
        console.log("@@Error:", error);
        reject(error);
      }
    });
  };

  const displayHistory = async () => {
    // console.log("displayHistory", selectedFiling);
    try {
      if (
        selectedFiling &&
        selectedFiling.length === 1 && selectedFiling[0].filingId === null
      ) {
        setAlertMessage("The file does not have any history yet because it has been newly created. History will appear once changes are made and saved.");
        setShowAlert(true);
        // console.log(`Fetching History for :${selectedFiling[0].filingId}`);
      } else if (selectedFiling.length > 1) {
        // console.log("selectedFilingLength3", selectedFiling.length);

        setAlertMessage("Please Select a single Filing Master Record");
        setShowAlert(true);
      } else if (selectedFiling.length === 0) {
        // console.log("selectedFilingLength2", selectedFiling.length);

        setAlertMessage("Please Select a Filing Master Record");
        setShowAlert(true);
      } else {
        console.log("selectedFiling", selectedFiling);
        fetchFilingMasterHistory(selectedFiling[0]);
        setShowHistory(() => true);
      }
    } catch (err) {
      console.log("err", err);
    }

  };

  const fetchFilingMasterComments = async (data) => {
    // console.log("@@Fetch FilingMasters1:", getFilingMasterWorkflowComments);
    if (getFilingMasterWorkflowComments) {
      // console.log("@@Fetch FilingMasters2:");
      try {
        let dataId =
          value === "2"
            ? { id: data.filingId, type: "filing" }
            : { id: data.workflowId, type: "workflow" };
        const commentList = await getFilingMasterWorkflowComments(dataId);
        setComments(() => commentList);
        // console.log("@@Fetch FilingMasters2 comments:", commentList);
      } catch (error) {
        console.log("@@Error:", error);
      }
    }
  };

  const displayAttachments = async (rowData) => {
    // console.log("##selectedFiling", selectedFiling[0]);
    // console.log("##selectedFiling-length", selectedFiling.length);
    // console.log("##RowData", rowData);
    // console.log("LengthSelectedFiling", selectedFiling.length);
    if (rowData && rowData.draftId) {
      // console.log(`##RowData-FilingId :${rowData.draftId}`);
      fetchFilingMasterAttachments(rowData.draftId, rowData.filingId);
      setShowAttachments(() => true);
      setSelectedFiling(() => []);
    } else if (
      selectedFiling &&
      selectedFiling.length === 1 &&
      selectedFiling[0].draftId
    ) {
      // console.log(`Fetching Attachment for :`, selectedFiling);
      fetchFilingMasterAttachments(
        selectedFiling[0].draftId,
        selectedFiling[0].filingId
      );
      setShowAttachments(() => true);
      setSelectedFiling(() => []);
    } else if (selectedFiling.length > 1) {
      setAlertMessage("Please Select a single Filing Master Record");
      setShowAlert(true);
    } else {
      setAlertMessage("Please Select a Filing Master Record");
      setShowAlert(true);
    }
  };

  const addComment = (rowData) => {
    console.log("Display Comments", selectedFiling);
    console.log("Display Comments rowData", rowData);
    if (rowData && rowData.workflowId) {
      fetchFilingMasterComments(rowData);
      setShowComments(() => true);
      setSelectedFiling([]);
      setSelectedRowData(rowData);
    } else if (
      selectedFiling &&
      selectedFiling.length === 1 &&
      selectedFiling[0].workflowId
    ) {
      // console.log(`Fetching Commnet for :${selectedFiling[0].workflowId}`);
      setSelectedRowData(null);

      fetchFilingMasterComments(selectedFiling[0]);

      setShowComments(() => true);
    } else {
      setAlertMessage("Please select a single Record");
      setShowAlert(true);
    }
  };

  const closeComments = () => {
    // console.log("Toggling Show Filter", showComments);
    setShowComments(() => false);
  };
  const getStateName = (stateCode) => {
    const state = states.find((s) => s.code === stateCode);
    return state ? state.state : stateCode;
  };
  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };
    _filters["global"].value = value;
    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const jusrisdictionItemTemplate = (option) => {
    return (
      <div className="flex align-items-center">
        <span>{option}</span>
      </div>
    );
  };

  const jusrisdictionArray = ["Federal", "State", "Both"];

  const jurisdictionRowFilterTemplate = (options) => {
    if (
      !federalFilterSelectedValues.jurisdiction &&
      options?.filterModel?.value
    ) {
      options.filterModel.value = null;
      options.value = null;
    }

    return (
      <Dropdown
        value={federalFilterSelectedValues.jurisdiction || []}
        options={jusrisdictionArray}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          setFederalFilterSelectedValues((prev) => {
            return { ...prev, jurisdiction: e.value };
          });
          options.filterCallback(e.value, options.index);
        }}
        placeholder="Any"
        className="p-column-filter"
        style={{ minWidth: "14rem", maxWidth: "14rem" }}
      />
    );
  };
  const handleRefreshList = () => {

    //Virtual scroll callback
    const vScroll = value === "1"
      ? dt.current.getVirtualScroller()
      : dtComp.current.getVirtualScroller();
    let range = vScroll.getRenderedRange();
    console.log("refreshTable vScroll", vScroll, range);

    let pageInView
    let noOfPages
    if (value === "1") {
      if (pendingTableData.length > 100) {
        pageInView = recordsInView - 2
        noOfPages = 2
      } else {
        pageInView = recordsInView - 1
        noOfPages = 1
      }
    } else {
      if (completedTableData.length > 100) {
        pageInView = recordsInView - 2
        noOfPages = 2
      } else {
        pageInView = recordsInView - 1
        noOfPages = 1
      }
    }
    let clientSelected = selectedFiling
    setRecordsInViewSafe(pageInView)
    setRefreshDetails({
      viewport: range.viewport,
      pageInView,
      noOfPages,
      clientSelected
    })

    // fetchFilingMasters();
    setIsLoading(true);
    setData([]);
    setInitialData([]);
    setPendingTableData([]);
    setCompletedTableData([]);
    setIsFilterChange([]);
    setSortingData({ sortBy: "", sortOrder: "" });
    setFederalFilterSelectedValues([]);
    setRefreshRecordList(true);
  }
  const fetchFilingMasters = async () => {
    // console.log("@@Fetch FilingMasters1:", getFilingMasterApprovals);
    setIsLoading(true);
    let _filters = { ...filters };
    search && search.current && (search.current.value = "");
    _filters && _filters["global"] && (_filters["global"].value = "");
    setFilters(_filters);
    setIsClearIcon(false);

    if (getFilingMasterApprovals) {
      // console.log("@@Fetch FilingMasters2:");
      try {
        let formData;
        if (roleType?.includes("Admin")) {
          formData = {
            recordType: "TrackNow",
          };
        } else {
          formData = { approverId: authUser.userId, recordType: "TrackNow" };
        }
        // if (roleType.includes("JSIPOC") || roleType.includes("JSISME")) {
        //   formData = { approverId: authUser.userId, recordType: "TrackNow" };
        // }
        // else {
        //   formData = {
        //     recordType: "TrackNow",
        //   }
        // }
        const list = await getFilingMasterApprovals(formData);
        // console.log("@@FilingMasters:", list);
      } catch (error) {
        console.log("@@Error:", error);
      }
    }
  };
  const fetchFilingMastersCompleted = async () => {
    let _filters = { ...filters };
    search && search.current && (search.current.value = "");
    _filters && _filters["global"] && (_filters["global"].value = "");
    setFilters(_filters);
    setIsClearIcon(false);

    // console.log("@@Fetch FilingMasters2:");
    setIsLoading(true);
    try {
      let formData;
      let filingList;

      if (roleType?.includes("Admin")) {
        formData = {
          recordType: "TrackNow",
        };
      } else {
        formData = { approverId: authUser.userId, recordType: "TrackNow" };
      }
      // console.log("formDataCheck", formData);
      if (formData?.approverId) {
        let listRes = await axios.get(
          `${API_BASE_URL}/FilingMaster/FilingMasterWorkflowList?ApproverId=${formData.approverId}&RecordType=${formData.recordType}&Year=${selectedYear}`
        );
        filingList = listRes.data.data;
        // console.log("@@FilingMastersCompList:", listRes);
      } else {
        let listRes = await axios.get(
          `${API_BASE_URL}/FilingMaster/FilingMasterWorkflowList?&RecordType=${formData.recordType}&Year=${selectedYear}`
        );
        filingList = listRes.data.data;
        // console.log("@@FilingMastersCompList:", listRes);
      }
      const updList = filingList
        .filter((item) => item.changesInprogress)
        .map((item) => {
          // console.log(`filtered data ...`, item);
          const _stateList = getStateName(item.stateInfo);

          if (item.juristiction?.includes("Federal")) {
            const categories = _.map(
              item.businessCategory,
              "businessCategoryName"
            ).join(", ");
            // console.log(
            //   `filingMasters ${item.filingMasters} cat...`,
            //   categories
            // );
            return {
              ...item,
              federalCategories: categories,
              stateList: _stateList,
            };
          } else {
            // console.log(
            //   "stateCategories:",
            //   item.filingName,
            //   item.stateInfo,
            //   item.businessCategory
            // );
            const categoriesState = item.businessCategory.filter((ele) =>
              ele.state ? ele.state === item.stateInfo : ele
            );
            // console.log("stateCategories:", item.filingName, categoriesState);
            const categories = categoriesState
              .map((ele) => ele.businessCategoryName)
              .join(", ");

            // console.log(
            //   `filingMasters ${item.filingMasters} cat...`,
            //   categories
            // );
            return {
              ...item,
              stateCategories: categories,
              stateList: _stateList,
            };
          }
        });
      // const _jusrisdictions = updList.map((item) =>
      //   item.juristiction ? item.juristiction : ""
      // );
      // const _uniqJurisdictions = Array.from(new Set(_jusrisdictions));
      // console.log("@@Unique Jurisdiction:", _uniqJurisdictions);
      // setJurisdiction(_uniqJurisdictions);
      // setInitialData(() => updList);
      // setData(() => updList);
      // let pendingList = updList.filter(
      //   (ele) => ele.workflowStatus === "Pending"
      // );
      // console.log("filter pendingList :", pendingList, updList);
      // setPendingTableData(() => pendingList);
      let completedList = updList.filter(
        (ele) => ele.workflowStatus !== "Pending"
      );
      // console.log("filter completedList :", completedList, updList);
      // completedList = completedList.filter(
      //   (value, index, self) =>
      //     index === self.findIndex((t) => t.filingId === value.filingId)
      // );

      // Storing latest records if completedList has same filingname based on updateDate

      let latestUpdates = {};

      completedList.forEach((ele) => {
        const filingId = ele.filingId;

        // Check if the filingId is already in the latestUpdates object
        if (latestUpdates[filingId]) {
          // Compare the updateDate with the stored one
          const storedUpdateDate = latestUpdates[filingId].updateDate;
          const currentUpdateDate = ele.updateDate;

          // If the current updateDate is greater, update the stored object
          if (currentUpdateDate > storedUpdateDate) {
            latestUpdates[filingId] = ele;
          }
        } else {
          // If filingId is not in latestUpdates, add it
          latestUpdates[filingId] = ele;
        }
      });

      completedList = Object.values(latestUpdates);

      // console.log("duplicate completedList :", completedList, updList);
      // console.log("");
      setCompletedTableData(() => completedList);
      // console.log("filingList", filingList, "updList", updList, "completedList", completedList);
    } catch (error) {
      console.log("@@Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const onRowSelect = (e) => {
    // console.log("@@RowSelect:", e);
  };

  const getAllAttachment = async (updList) => {
    updList = await Promise.all(
      updList.map(async (ele) => {
        ele.attachment = await getFileAttachment(ele);
        return ele;
      })
    );
    setData(() => updList);
  };

  const getFileAttachment = async (ele) => {
    // console.log("getFileAttachment-->", ele);
    await axios
      .get(
        `${API_BASE_URL}/FilingMaster/FilingMasterAttachmentsGetById/${ele.filingId}`
      )
      .then((res) => {
        // console.log("getFileAttachment res", ele, ele.filingId, res.data);
        if (res.data) {
          return res.data.attachmentPath;
        }
      });
  };

  useEffect(() => {
    if (filingMasterLoaded) {
      // console.log("Show Table Data", filingMasterApprovals);
      // const updList = filingMasterApprovals
      //   .filter((item) => item.changesInprogress)
      //   .map((item) => {
      //     // console.log(`filtered data ...`, item);
      //     const _stateList = getStateName(item.stateInfo);
      //     if (item.juristiction?.includes("Federal")) {
      //       const categories = _.map(
      //         item.businessCategory,
      //         "businessCategoryName"
      //       ).join(", ");
      //       // console.log(
      //       //   `filingMasters ${item.filingMasters} cat...`,
      //       //   categories
      //       // );
      //       return {
      //         ...item,
      //         federalCategories: categories,
      //         stateList: _stateList,
      //       };
      //     } else {
      //       // console.log(
      //       //   "stateCategories:",
      //       //   item.filingName,
      //       //   item.stateInfo,
      //       //   item.businessCategory
      //       // );
      //       const categoriesState = item.businessCategory.filter((ele) =>
      //         ele.state ? ele.state === item.stateInfo : ele
      //       );
      //       // console.log("stateCategories:", item.filingName, categoriesState);
      //       const categories = categoriesState
      //         .map((ele) => ele.businessCategoryName)
      //         .join(", ");
      //       // console.log(
      //       //   `filingMasters ${item.filingMasters} cat...`,
      //       //   categories
      //       // );
      //       return {
      //         ...item,
      //         stateCategories: categories,
      //         stateList: _stateList,
      //       };
      //     }
      //   });
      // const _jusrisdictions = updList.map((item) =>
      //   item.juristiction ? item.juristiction : ""
      // );
      // const _uniqJurisdictions = Array.from(new Set(_jusrisdictions));
      // // console.log("@@Unique Jurisdiction:", _uniqJurisdictions);
      // setJurisdiction(_uniqJurisdictions);
      // setInitialData(() => updList);
      // setData(() => updList);
      // let pendingList = updList.filter(
      //   (ele) => ele.workflowStatus === "Pending"
      // );
      // console.log("filter pendingList :", pendingList, updList);
      // setPendingTableData(() => pendingList);
      // let completedList = updList.filter(
      //   (ele) => ele.workflowStatus !== "Pending"
      // );
      // // console.log("filter completedList :", completedList, updList);
      // completedList = completedList.filter(
      //   (value, index, self) =>
      //     index === self.findIndex((t) => t.filingId === value.filingId)
      // );
      // // console.log("duplicate completedList :", completedList, updList);
      // setCompletedTableData(() => completedList);
      // setIsLoading(false);
    }
  }, [filingMasterLoaded]);
  const fetchConfigs = async () => {
    if (fetchConfigurations) {
      let config = await fetchConfigurations();
      let startYear = config.find(
        (ele) => ele.configItem === "StartYear"
      ).configItemValue;
      let currentYear = config.find(
        (ele) => ele.configItem === "CurrentYear"
      ).configItemValue;
      startYear = parseInt(startYear);
      currentYear = parseInt(currentYear);
      const yearsInBetween = [];
      for (let year = startYear; year <= currentYear + 1; year++) {
        yearsInBetween.push(year);
      }
      setYearsList(yearsInBetween);
      setSelectedYear(currentYear);
      // console.log(
      //   'configCheck',
      //   config,
      //   'StartYear',
      //   startYear,
      //   'currentYear',
      //   currentYear,
      //   'yearsInBetween',
      //   yearsInBetween
      // );
    }
  };

  const fetchBusinessCategories = async () => {
    if (!getBusinessCategories) {
      return;
    }
    try {
      const resList = await getBusinessCategories();
      const lookup = (resList || [])
        .map((item) => item?.businessCategoryName)
        .filter(Boolean)
        .sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
      setCategoryList(lookup);
    } catch (error) {
      console.log("@@Error:", error);
    }
  };

  useEffect(() => {
    fetchConfigs();
    fetchBusinessCategories();
  }, []);

  useEffect(() => {
    // console.log("InitialCheck2", selectedYear, value);
    if (value === "2") {
      // console.log("InitialCheck3", selectedYear, value);
      // fetchFilingMastersCompleted()
      setRecordsInViewSafe(0);
      setIsLoading(true);
      setData([]);
      setInitialData([]);
      setPendingTableData([]);
      setCompletedTableData([]);
      setIsFilterChange([]);
      setSortingData({ sortBy: "", sortOrder: "" });
      setFederalFilterSelectedValues([]);
      setRefreshRecordList(true);
    }
  }, [selectedYear]);

  useEffect(() => {
    let list = states.map((ele) => ele.state);
    setStateArray(list);
    // fetchFilingMasters();
    setRecordsInViewSafe(0);
    setIsLoading(true);
    setData([]);
    setInitialData([]);
    setPendingTableData([]);
    setCompletedTableData([]);
    setIsFilterChange([]);
    setSortingData({ sortBy: "", sortOrder: "" });
    setFederalFilterSelectedValues([]);
    setRefreshRecordList(true);
  }, []);
  const handleYearChange = (event) => {
    setSelectedYear(event.target.value);
  };
  const handleChange = useCallback((state) => {
    setSelectedRows(state.selectedRows);
  }, []);

  const requiredArray = ["True", "False"];

  const requiredRowFilterTemplate = (options) => {
    // console.log("requiredRowFilterTemplate:", options,masterCatFilter);
    if (!federalFilterSelectedValues.required && options?.filterModel?.value) {
      // console.log("requiredRowFilterTemplate filterModel",options.filterModel);
      options.filterModel.value = null;
      options.value = null;
    }

    return (
      <Dropdown
        value={federalFilterSelectedValues.required || []}
        options={requiredArray}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          setFederalFilterSelectedValues((prev) => {
            return { ...prev, required: e.value };
          });
          options.filterCallback(e.value, options.index);
        }}
        placeholder="Any"
        className="p-column-filter"
        style={{ minWidth: "14rem", maxWidth: "14rem" }}
      />
    );
  };

  const federalFilterElement = (options, field, tab) => {
    // console.log("##OptionsCheck", options, field);
    let optionsList = [];
    data
      .map((item) => item[field])
      .filter(Boolean)
      .map((item) => {
        if (item.includes(",")) {
          //console.log("spliited_item", item);
          item.split(",").map((subItem) => {
            optionsList.push(subItem && subItem.trim());
          });
        } else {
          optionsList.push(item.trim());
        }
      });
    optionsList = optionsList
      .filter((item, i) => {
        return i === optionsList.lastIndexOf(item);
      })
      .sort();

    let _dataClone =
      tab === "pending"
        ? data.filter((ele) => ele.workflowStatus === "Pending")
        : data
          .filter((ele) => ele.workflowStatus !== "Pending")
          .filter(
            (value, index, self) =>
              index === self.findIndex((t) => t.filingId === value.filingId)
          );
    // console.log("roleTypeCheck", roleType, authUser);
    return options.filterModel?.matchMode &&
      options.filterModel.matchMode === "in" ? (
      <MultiSelect
        value={federalFilterSelectedValues[field] || []}
        options={optionsList}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          // console.log("##federalFilterElement#:", options, e, _dataClone);
          setFederalFilterSelectedValues((prev) => {
            return { ...prev, [field]: e.value };
          });
          options.filterCallback(e.value, options.index);
        }}
        placeholder="Any"
        maxSelectedLabels={1}
        className="p-column-filter"
        style={{ minWidth: "14rem", maxWidth: "14rem" }}
      />
    ) : (
      <Dropdown
        value={federalFilterSelectedValues[field] || []}
        options={optionsList}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          // console.log("##federalFilterElement#:", options, e, data);
          setFederalFilterSelectedValues((prev) => {
            return { ...prev, [field]: e.value };
          });
          let values = [];

          if (options.filterModel.matchMode === "equals") {
            values.push(e.value);
          } else if (options.filterModel.matchMode === "notContains") {
            values.push(e.value);
          }
          options.filterCallback(values, options.index);
        }}
        placeholder="Any"
        className="p-column-filter"
        style={{ minWidth: "14rem", maxWidth: "14rem" }}
      />
    );
  };

  const stateRowFilterTemplate = (options) => {
    // console.log("##Options:", options);
    if (
      !federalFilterSelectedValues?.stateList &&
      options?.filterModel?.value
    ) {
      // console.log(" optionsfilterModel", options.filterModel);
      options.filterModel.value = null;
      options.value = null;
    }
    return options.filterModel?.matchMode &&
      options.filterModel.matchMode === "in" ? (
      <MultiSelect
        value={federalFilterSelectedValues.stateList || []}
        options={stateArray}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          // console.log("##EOptions:", e);
          setFederalFilterSelectedValues((prev) => {
            return { ...prev, stateList: e.value };
          });
          options.filterCallback(e.value, options.index);
          // options.filterApplyCallback(e.value);
        }}
        placeholder="Any"
        maxSelectedLabels={1}
        className="p-column-filter"
        style={{ minWidth: "11rem", maxWidth: "11rem" }}
      />
    ) : (
      <Dropdown
        value={federalFilterSelectedValues.stateList || []}
        options={stateArray}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          // console.log("##EOptions:", e);
          setFederalFilterSelectedValues((prev) => {
            return { ...prev, stateList: e.value };
          });
          options.filterCallback(e.value, options.index);
          // options.filterApplyCallback(e.value);
        }}
        placeholder="Any"
        className="p-column-filter"
        style={{ minWidth: "12rem", maxWidth: "13rem" }}
      />
    );
  };
  const displayTimeStamp = (rowData) => {
    return rowData.recentDate ? toLocalDateTime(rowData.recentDate) : ""
  }

  const parseCellList = (value) =>
    typeof value === "string"
      ? value.split(",").map((item) => item.trim()).filter(Boolean)
      : [];

  const hideOtherCellOverlays = (currentKey) => {
    Object.entries(overlayRefs.current).forEach(([key, overlay]) => {
      if (key !== currentKey && overlay?.hide) {
        overlay.hide();
      }
    });
  };

  const getPreferredOverlayDirection = (cellElement) => {
    const row = cellElement?.closest("tr");
    const body = row?.parentElement;

    if (row && body) {
      const rows = Array.from(body.children).filter(
        (node) => node.tagName === "TR"
      );
      const rowIndex = rows.indexOf(row);

      if (rowIndex >= rows.length - 3) {
        return "up";
      }
      if (rowIndex <= 2) {
        return "down";
      }
    }

    const cellRect = cellElement?.getBoundingClientRect();
    if (!cellRect) {
      return "down";
    }
    return cellRect.bottom > window.innerHeight * 0.7 ? "up" : "down";
  };

  const positionOverlayNearCell = (overlayKey, cellElement, preferredDirection) => {
    const overlayPanel = overlayRefs.current[overlayKey];
    const overlayElement = overlayPanel?.container;
    if (!overlayElement || !cellElement || overlayElement.style.display === "none") {
      return;
    }

    const cellRect = cellElement.getBoundingClientRect();
    const overlayRect = overlayElement.getBoundingClientRect();
    const gap = 8;
    const viewportHeight = window.innerHeight;
    const viewportWidth = window.innerWidth;
    const canOpenDown = cellRect.bottom + overlayRect.height + gap <= viewportHeight;
    const canOpenUp = cellRect.top - overlayRect.height - gap >= gap;

    let openUp = false;
    if (preferredDirection === "up" && canOpenUp) {
      openUp = true;
    } else if (preferredDirection === "down" && !canOpenDown && canOpenUp) {
      openUp = true;
    } else if (!canOpenDown && canOpenUp) {
      openUp = true;
    }

    let top = openUp
      ? cellRect.top - overlayRect.height - gap
      : cellRect.bottom + gap;
    let left = cellRect.left + cellRect.width / 2 - overlayRect.width / 2;

    left = Math.min(Math.max(left, gap), viewportWidth - overlayRect.width - gap);
    top = Math.min(Math.max(top, gap), viewportHeight - overlayRect.height - gap);

    overlayElement.style.position = "fixed";
    overlayElement.style.left = `${Math.round(left)}px`;
    overlayElement.style.top = `${Math.round(top)}px`;
    overlayElement.style.transform = "none";
  };

  const toggleCellOverlay = (event, overlayKey) => {
    event.stopPropagation();
    event.preventDefault();
    const targetElement = event.currentTarget;

    const overlayPanel = overlayRefs.current[overlayKey];
    if (!overlayPanel?.toggle) return;

    const overlayElement = overlayPanel.container;
    const isVisible = Boolean(
      overlayElement && overlayElement.style.display !== "none"
    );

    if (!isVisible) {
      hideOtherCellOverlays(overlayKey);
    }

    overlayPanel.toggle(event);

    requestAnimationFrame(() => {
      const preferredDirection = getPreferredOverlayDirection(targetElement);
      positionOverlayNearCell(overlayKey, targetElement, preferredDirection);
    });
  };

  const renderExpandableCell = ({ list, overlayKey, title }) => {
    if (list.length === 0) return "";

    const hasValue = list.length > 0;
    const hasMore = list.length > 1;
    const firstItem = list[0];
    const remainingCount = Math.max(list.length - 1, 0);

    return (
      <div className='tableBtn' style={{ position: "relative", width: "100%" }}>
        <button
          type='button'
          onClick={(event) => {
            if (!hasValue) return;
            toggleCellOverlay(event, overlayKey);
          }}
          style={{
            background: "transparent",
            border: "none",
            cursor: hasValue ? "pointer" : "default",
            width: "100%",
            padding: 0,
            textAlign: "left",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              color: tableHeaderColor,
              overflow: "hidden",
              display: "flex",
              alignItems: "center",
              gap: "6px",
              whiteSpace: "nowrap",
              minWidth: 0,
            }}
          >
            <span
              style={{
                flex: "1 1 auto",
                minWidth: 0,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {firstItem}
            </span>
            {hasMore && (
              <span
                style={{
                  flex: "0 0 auto",
                  fontSize: "12px",
                  color: tableHeaderColor,
                  whiteSpace: "nowrap",
                }}
              >
                {`+${remainingCount} more`}
              </span>
            )}
          </div>
        </button>
        {hasValue && (
          <OverlayPanel
            ref={(el) => {
              if (el) {
                overlayRefs.current[overlayKey] = el;
              }
            }}
            className='client-profile-overlay-panel filing-master-approval-overlay-panel'
            showCloseIcon
            dismissable
            style={{
              padding: "0.4rem 0.8rem",
              width: "min(22rem, calc(100vw - 1rem))",
              maxWidth: "min(22rem, calc(100vw - 1rem))",
              maxHeight: "min(18rem, calc(100vh - 1rem))",
            }}
          >
            <Typography variant='subtitle2' sx={{ mb: 1, fontWeight: 600 }}>
              {title}
            </Typography>
            <div className="overlay-scroll-consistent" style={{ width: "100%", maxWidth: "100%", maxHeight: "10.5rem", overflowY: "auto", overflowX: "hidden", paddingRight: "0.25rem", boxSizing: "border-box" }}>
              <ul style={{ paddingLeft: "20px", margin: 0 }}>
                {list.map((item, idx) => (
                  <li key={`${item}-${idx}`} style={{ marginBottom: "4px", overflowWrap: "anywhere" }}>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </OverlayPanel>
        )}
      </div>
    );
  };

  const CellListDisplayFederal = (rowData, field) => {
    const categories = rowData[field]
      ? field === "federalCategories"
        ? rowData.businessCategory.map((ele) => ele.businessCategoryName)
        : rowData.businessCategory
          .filter((ele) => ele.state === rowData.stateInfo)
          .map((ele) => ele.businessCategoryName)
      : [];

    const title = field === "federalCategories"
      ? "Who Must File Federal"
      : "Who Must File in State";

    const overlayKey = `${field}-${rowData.workflowId || rowData.filingId}`;

    return renderExpandableCell({
      list: categories,
      overlayKey: overlayKey,
      title: title,
    });
  };

  const cellListDisplayName = (rowData) => {
    return (
      <LightTooltip title={rowData.filingName}>
        <div
          style={{
            width: "inherit",
            margin: "0 1rem",
            overflow: "hidden",
            textOverflow: "ellipsis",
            color: tableHeaderColor,
            cursor: "pointer",
            transition: "font-weight 0.2s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.fontWeight = '600';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.fontWeight = '400';
          }}
        >
          {rowData.filingName}
        </div>
      </LightTooltip>
    );
  };

  const cellListDisplayRuleInfo = (rowData) => {
    const ruleInfoValue = capitalizeLeadingText(rowData.ruleInfo);
    return (
      <LightTooltip title={ruleInfoValue}>
        <div
          style={{
            width: "12rem",
            margin: "0 1rem",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {ruleInfoValue}
        </div>
      </LightTooltip>
    );
  };

  const cellListDisplayNotes = (rowData) => {
    const notesUrl = rowData.notes;
    const urlRegex = /(https?:\/\/[^\s]+)/g;

    if (!notesUrl) return null;

    const formattedText = notesUrl.replace(
      urlRegex,
      '<a style="color:#0000FF;" href="$&" target="_blank" rel="noopener noreferrer">$&</a>'
    );

    return (
      <LightTooltip
        arrow
        title={
          <div
            style={{
              maxWidth: "350px",
              maxHeight: "250px",
              overflowY: "auto",
              overflowX: "hidden",
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              overflowWrap: "anywhere",
              padding: "4px",// Added top/bottom & left/right padding
              fontWeight: "normal",   // Remove bold
              lineHeight: "1.5",      // Better readability
              fontSize: "14px",
            }}
            dangerouslySetInnerHTML={{ __html: formattedText }}
          />
        }
      >
        <div
          style={{
            width: "100%",
            maxWidth: "20rem",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            cursor: "pointer",
          }}
          dangerouslySetInnerHTML={{ __html: formattedText }}
        />
      </LightTooltip>
    );
  };

  const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#F1F2F6",
      color: "black",
      boxShadow: theme.shadows[1],
      fontSize: 12,
    },
  }));

  useEffect(() => {
    // console.log("state", selectedRows);
  }, [selectedRows]);

  useEffect(() => {
    // console.log("pendingMyRequests", pendingMyRequests);
  }, [pendingMyRequests]);

  const renderHeader = () => {
    return (
      <Grid
        container
        spacing={2}
        sx={{
          mb: 2,
          background: containerBackgroundColor,
          p: 2,
          borderRadius: "8px",
        }}
      >
        {/* TITLE */}
        <Grid item xs={12}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              fontSize: "20px",
              color: tableHeaderColor,
              display: "flex",
              alignItems: "center",
            }}
          >
            FILING MASTER APPROVALS ({totalRecords})
          </Typography>
        </Grid>

        {/* FILTER + CHIPS */}
        <Grid item xs={12} md={7}>
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
            <TrackNowButton
              variant="secondary"
              size="small"
              onClick={handleFilterClick}
            >
              + Filter
            </TrackNowButton>

            <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mt: 1 }}>
              {activeFilters.map((filter) => (
                <Box
                  key={filter.id}
                  sx={{
                    display: "inline-flex",
                    alignItems: "center",
                    backgroundColor: containerBackgroundColor,
                    border: "1px solid #ccc",
                    borderRadius: "20px",
                    px: 1.5,
                    py: 0.75,
                    fontSize: "13px",
                    color: "#333",
                  }}
                >
                  {filter.label || getFilterChipLabel(filter.field)}:{" "}
                  {Array.isArray(filter.displayValue ?? filter.value)
                    ? (filter.displayValue ?? filter.value).join(", ")
                    : (filter.displayValue ?? filter.value)}

                  <button
                    onClick={() => removeFilter(filter.id)}
                    style={{
                      marginLeft: "6px",
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      color: "#666",
                      fontSize: "16px",
                      lineHeight: 1,
                    }}
                    type="button"
                  >
                    &times;
                  </button>
                </Box>
              ))}
            </Box>
          </Box>
        </Grid>

        {/* SEARCH */}
        <Grid item xs={12} md={5}>
          <Box
            sx={{
              display: "flex",
              justifyContent: { xs: "flex-start", md: "flex-end" },
            }}
          >
            <TextField
              inputRef={search}
              placeholder="Search by Filing Name..."
              size="small"
              sx={{
                width: { xs: "100%", sm: 260 },
                "& .MuiOutlinedInput-root": {
                  borderRadius: "20px",
                  backgroundColor: containerBackgroundColor,
                },
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={applyGlobalFilter} edge="end" size="small">
                      {isClearIcon ? <GoogleMaterialIcon name="clear" size={20} /> : <GoogleMaterialIcon name="search" size={20} />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        </Grid>
      </Grid>
    );
  };

  const renderCompletedHeader = () => {
    return (
      <Grid
        container
        spacing={2}
        sx={{
          mb: 2,
          background: containerBackgroundColor,
          p: 2,
          borderRadius: "8px",
        }}
      >
        {/* TITLE */}
        <Grid item xs={12}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              fontSize: "20px",
              color: tableHeaderColor,
              display: "flex",
              alignItems: "center",
            }}
          >
            FILING MASTER APPROVALS ({totalRecords})
          </Typography>
        </Grid>

        {/* FILTER + CHIPS */}
        <Grid item xs={12} md={7}>
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
            <TrackNowButton
              variant="secondary"
              size="small"
              onClick={handleFilterClick}
            >
              + Filter
            </TrackNowButton>

            <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mt: 1 }}>
              {activeFilters.map((filter) => (
                <Box
                  key={filter.id}
                  sx={{
                    display: "inline-flex",
                    alignItems: "center",
                    backgroundColor: containerBackgroundColor,
                    border: "1px solid #ccc",
                    borderRadius: "20px",
                    px: 1.5,
                    py: 0.75,
                    fontSize: "13px",
                    color: "#333",
                  }}
                >
                  {filter.label || getFilterChipLabel(filter.field)}:{" "}
                  {Array.isArray(filter.displayValue ?? filter.value)
                    ? (filter.displayValue ?? filter.value).join(", ")
                    : (filter.displayValue ?? filter.value)}

                  <button
                    onClick={() => removeFilter(filter.id)}
                    style={{
                      marginLeft: "6px",
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      color: "#666",
                      fontSize: "16px",
                      lineHeight: 1,
                    }}
                    type="button"
                  >
                    &times;
                  </button>
                </Box>
              ))}
            </Box>
          </Box>
        </Grid>

        {/* YEAR + SEARCH */}
        <Grid item xs={12} md={5}>
          <Box
            sx={{
              display: "flex",
              gap: 2,
              flexWrap: "wrap",
              justifyContent: { xs: "flex-start", md: "flex-end" },
            }}
          >
            {value === "2" && (
              <FormControl size="small" sx={{ minWidth: 120 }}>
                <InputLabel>Year</InputLabel>
                <Select value={selectedYear} label="Year" onChange={handleYearChange}>
                  {yearsList.map((year) => (
                    <MenuItem key={year} value={year}>
                      {year}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}

            <TextField
              inputRef={search}
              placeholder="Search by Filing Name..."
              size="small"
              sx={{
                width: { xs: "100%", sm: 260 },
                "& .MuiOutlinedInput-root": {
                  borderRadius: "20px",
                  backgroundColor: containerBackgroundColor,
                },
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={applyGlobalFilter} edge="end" size="small">
                      {isClearIcon ? <GoogleMaterialIcon name="clear" size={20} /> : <GoogleMaterialIcon name="search" size={20} />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        </Grid>
      </Grid>
    );
  };

  const updateSelectedWorkflow = (workflow) => {
    // // console.log("SELECT FILING UPDTAE", workflow);
    if (workflow) setSelectedFiling([workflow]);
    else setSelectedFiling([]);
    setExpandedRows(null);
    setRecordsInViewSafe(0);
    setIsLoading(true);
    setData([]);
    setInitialData([]);
    setPendingTableData([]);
    setCompletedTableData([]);
    setIsFilterChange([]);
    setSortingData({ sortBy: "", sortOrder: "" });
    setFederalFilterSelectedValues([]);
    setRefreshRecordList(true);
  };

  const CustomCommentButton = ({ rowData }) => {
    const isActive = Boolean(rowData.hasComments);
    return (
      <IconButton
        size="small"
        disabled={!isActive}
        onClick={() => addComment(rowData)}
        sx={{
          p: "4px",
          width: 28,
          height: 28,
          minWidth: 28,
          minHeight: 28,
          pointerEvents: !isActive ? 'none' : 'auto',
          cursor: !isActive ? 'default' : 'pointer',
          backgroundColor: isActive ? 'color-mix(in srgb, var(--tn-primary-color, #432568) 12%, white)' : '#f5f5f5',
          '&:hover': {
            backgroundColor: isActive ? 'color-mix(in srgb, var(--tn-primary-color, #432568) 12%, white)' : '#f5f5f5'
          }
        }}
      >
        <GoogleMaterialIcon
          name="comment"
          size={20}
          color={isActive ? tableHeaderColor : tokens.colors.grey}
        />
      </IconButton>
    );
  };
  const FilingAttachmentButton = ({ rowData }) => {
    const isActive = Boolean(rowData.hasReference);
    return (
      <IconButton
        size="small"
        disabled={!isActive}
        onClick={() => displayAttachments(rowData)}
        sx={{
          p: "4px",
          width: 28,
          height: 28,
          minWidth: 28,
          minHeight: 28,
          pointerEvents: !isActive ? 'none' : 'auto',
          cursor: !isActive ? 'default' : 'pointer',
          backgroundColor: isActive ? 'color-mix(in srgb, var(--tn-primary-color, #432568) 12%, white)' : '#f5f5f5',
          '&:hover': {
            backgroundColor: isActive ? 'color-mix(in srgb, var(--tn-primary-color, #432568) 12%, white)' : '#f5f5f5'
          }
        }}
      >
        <GoogleMaterialIcon
          name="snippet_folder"
          size={20}
          color={isActive ? tableHeaderColor : tokens.colors.grey}
        />
      </IconButton>
    );
  };
  const header = renderHeader();
  const completedHeader = renderCompletedHeader();

  const closeAlert = () => {
    setShowAlert(false);
  };

  const handleTabChange = (event, newValue) => {
    setFederalFilterSelectedValues([]);
    setSelectedFiling([]);
    setExpandedRows(null);
    setValue(newValue);
    let _filters = { ...filters };
    search.current.value = "";
    _filters["global"].value = "";
    setFilters(_filters);
    setActiveFilters((prev) =>
      prev.filter((f) =>
        (newValue === "1" ? pendingFilterColumns : completedFilterColumns).includes(f.field)
      )
    );
    setIsClearIcon(false);
    setGlobalFilterValue("");
    if (newValue === "2") {
      // fetchFilingMastersCompleted()
      setIsDisabled(true);
      // console.log("InitialCheck1", selectedYear, newValue);
      setRecordsInViewSafe(0);
      setIsLoading(true);
      setData([]);
      setInitialData([]);
      setPendingTableData([]);
      setIsFilterChange([]);
      setSortingData({ sortBy: "", sortOrder: "" });
      setFederalFilterSelectedValues([]);
      setRefreshRecordList(true);
    } else {
      // fetchFilingMasters()
      setIsDisabled(false);
      setRecordsInViewSafe(0);
      setIsLoading(true);
      setData([]);
      setInitialData([]);
      setCompletedTableData([]);
      setIsFilterChange([]);
      setSortingData({ sortBy: "", sortOrder: "" });
      setFederalFilterSelectedValues([]);
      setRefreshRecordList(true);
    }
  };

  const rowExpansionTemplate = (data) => {
    console.log("rowExpansionTemplate", data.filingPeriods);
    if (data.filingPeriods.length > 0) {
      let tableData = data.filingPeriods.map((ele) => {
        let startDate = new Date(ele.startDate);
        let endDate = new Date(ele.endDate);
        const toLocalDateString = (date) => {
          const options = { month: "2-digit", day: "2-digit", year: "numeric" };
          return date
            .toLocaleDateString("en-US", options)
            .replace(
              /(\d+)\/(\d+)\/(\d+)/,
              (_, month, day, year) =>
                `${month.padStart(2, "0")}/${day.padStart(2, "0")}/${year}`
            );
        };

        let fp = `${toLocalDateString(startDate)} - ${toLocalDateString(
          endDate
        )}`;
        let dueDate =
          ele.dueDate !== null
            ? toLocalDateString(new Date(ele.dueDate))
            : null;
        console.log("dueDateCheck#", dueDate);
        return {
          startDate: ele.startDate,
          endDate: ele.endDate,
          filingPeriod: fp,
          dueDate: dueDate,
        };
      });
      return (
        <div className="filingPeriodTable p-3" style={{ width: "50vw" }}>
          <h5>Due Dates for {data.filingName}</h5>
          <DataTable value={tableData}>
            <Column field="filingPeriod" header="Filing Period"></Column>
            <Column field="dueDate" header="DueDate"></Column>
          </DataTable>
        </div>
      );
    } else {
      return (
        <div className="filingPeriodTable p-3">
          <h5>No Due Dates for {data.filingName}</h5>
        </div>
      );
    }
  };

  const rowExpand = (event) => {
    console.log("rowExpand", event, expandedRows);
    // const newKeys =
    //   expandedRows !== null && expandedRows !== undefined
    //     ? Object.keys(event.data).filter(
    //         (key) => !expandedRows.hasOwnProperty(key)
    //       )[0]
    //     : Object.keys(event.data)[0];
    // let newExpanded = {};
    // newExpanded[newKeys] = event.data[newKeys];
    // console.log("rowExpand", newKeys, newExpanded);
    setExpandedRows(event.data);
  };

  const isExpandedParentRow = (rowData) => {
    if (!expandedRows || !rowData) return false;
    const rowKey = rowData.workflowId;
    if (Array.isArray(expandedRows)) {
      return expandedRows.some((row) => row?.workflowId === rowKey);
    }
    if (typeof expandedRows === "object") {
      return Object.prototype.hasOwnProperty.call(expandedRows, rowKey);
    }
    return false;
  };

  const onRowExpand = (event) => {
    console.log("rowExpand-->", event);
    getFilingPeriod(event.data);
  };

  const getFilingPeriod = async (data) => {
    console.log("@@Fetch getFilingPeriod", data?.filingId);
    try {
      const filingPeriod = await axios.get(
        `${API_BASE_URL}/FilingMaster/ListFilingMasterDraftPeriods/${data?.filingId}`
      );
      console.log("getFilingPeriod res", filingPeriod.data.data);
      let tableData = filingPeriod.data.data.map((ele) => {
        let fp = `${toLocalTime(ele.startDate)} - ${toLocalTime(ele.endDate)}`;
        return {
          startDate: ele.startDate,
          endDate: ele.endDate,
          filingPeriod: fp,
          dueDate: toLocalTime(ele.dueDate),
          initialDueDate: toLocalTime(ele.dueDate),
        };
      });
      console.log("getFilingPeriod tableData", tableData);
      setFilingPeriodTable(tableData);
    } catch (error) {
      console.log("@@Error:", error);
    }
  };

  const toLocalTime = (date) => {
    if (date) {
      const _date = DateTime.fromFormat(
        DateTime.fromISO(date.toString()).toFormat("dd-MMM-yyyy hh:mm:ss"),
        "dd-MMM-yyyy hh:mm:ss",
        { zone: "UTC" }
      )
        .toLocal()
        .toFormat("dd-MMM-yy");
      console.log("@@@ LocalllTime:", _date);

      return _date;
    } else return "";
  };

  const dt = useRef(null);
  const dtComp = useRef(null);
  const pageSize = 100;

  // lazy load function
  const loadDataLazy = async (event) => {
    console.log("loadDataLazy props", recordsInViewRef.current, event);

    if (lazyLoadInFlightRef.current || lazyLoading) {
      return;
    }

    //Virtual scroll callback

    const vScroll =
      value === "1"
        ? dt.current?.getVirtualScroller?.()
        : dtComp.current?.getVirtualScroller?.();
    if (!vScroll?.getRenderedRange) {
      return;
    }

    let range = vScroll.getRenderedRange();
    if (!range?.viewport) {
      return;
    }
    let { first, last } = range.viewport;
    console.log("loadDataLazy vScroll", vScroll, range.viewport);

    let firstVal = recordsInViewRef.current * pageSize;
    let tableList = value === "1" ? pendingTableDataRef.current : completedTableDataRef.current;
    console.log(
      "loadDataLazy totalRecords",
      firstVal,
      totalRecords,
      lazyLoading,
      tableList.length
    );

    console.log(
      "loadDataLazy scroll check:",
      "first:", first,
      "tableList.length:", tableList.length,
      "threshold:", tableList.length - pageSize / 5,
      "firstVal:", firstVal,
      "totalRecords:", totalRecords,
      "lazyLoading:", lazyLoading
    );

    if (
      firstVal < totalRecords &&
      first > tableList.length - pageSize / 5 &&
      !lazyLoading
    ) {
      //scroll down
      lazyLoadInFlightRef.current = true;
      setLazyLoading(true);
      let lastVal = Math.min(firstVal + pageSize, totalRecords);
      console.log("loadDataLazy d firstVal", firstVal, lastVal);

      //get next data
      try {
        let records = await loadRecordsList(firstVal, lastVal, "down");
        console.log("loadDataLazy d record", records);
        if (Array.isArray(records) && records.length > 0) {
          console.log("loadDataLazy d scrollInView", recordsInViewRef.current * 100);

          //scroll to next records
          if (typeof vScroll.scrollInView === "function") {
            vScroll.scrollInView(recordsInViewRef.current * 100);
          } else if (typeof vScroll.scrollToIndex === "function") {
            vScroll.scrollToIndex(recordsInViewRef.current * 100);
          }
          setRecordsInViewSafe((old) => old + 1);
        }
      } finally {
        setLazyLoading(false);
        setIsLoading(false);
        lazyLoadInFlightRef.current = false;
      }
    } else if (last < pageSize / 5 && recordsInViewRef.current > 1 && !lazyLoading) {
      // scroll up
      let firstVal = (recordsInViewRef.current - 3) * pageSize;
      let lastVal = Math.min(firstVal + pageSize, totalRecords);
      if (firstVal >= 0) {
        lazyLoadInFlightRef.current = true;
        setLazyLoading(true);
        try {
          //get prev data
          let records = await loadRecordsList(firstVal, lastVal, "up");
          //scroll to prev records - scroll to middle to prevent immediate re-trigger
          if (Array.isArray(records) && records.length > 0) {
            if (typeof vScroll.scrollToIndex === "function") {
              vScroll.scrollToIndex(pageSize * 1.5);
            } else if (typeof vScroll.scrollInView === "function") {
              vScroll.scrollInView(pageSize * 1.5);
            }
            setRecordsInViewSafe((old) => old - 1);
          }
        } finally {
          setLazyLoading(false);
          setIsLoading(false);
          lazyLoadInFlightRef.current = false;
        }
      }
    }
  };

  const loadRecordsList = async (first, last, direction) => {
    // console.log("loadRecordsList props", first, last, direction);
    let url = `${API_BASE_URL}/FilingMaster/FilingMasterWorkflowListbyPagination?StartRow=${first + 1}&EndRow=${last}&RecordType=TrackNow`;

    // console.log("loadRecordsList recordTypeVal", recordTypeVal);
    // if (recordTypeVal !== "") {
    //   url = `${url}&RecordType=${recordTypeVal}`;
    // }

    console.log("loadRecordsList selectedYear", value, selectedYear);
    if (value === "2" && selectedYear !== "") {
      url = `${url}&StatusMove=Completed&Year=${selectedYear}`;
    }

    // console.log("loadRecordsList fliter/sort", isFilterChange, sortingData);
    if (isFilterChange !== undefined && isFilterChange.length > 0) {
      // url filter parameters
      isFilterChange.forEach((ele) => {
        const filterName = encodeURIComponent(ele.name);
        const filterValue = encodeURIComponent(ele.val);
        const searchType = ele.searchType ? encodeURIComponent(ele.searchType) : "";
        const searchTypeVal = ele.searchTypeVal
          ? encodeURIComponent(ele.searchTypeVal)
          : "";
        url = `${url}&${filterName}=${filterValue}${ele.searchType ? `&${searchType}=${searchTypeVal}` : ``}`;
      });
    }

    if (
      sortingData &&
      typeof sortingData === "object" &&
      sortingData.sortBy !== "" &&
      sortingData.sortOrder !== ""
    ) {
      // url sort parameters
      let sortParameter = getSortData(sortingData.sortBy);
      console.log("getSortData", sortParameter);
      let order = sortingData.sortOrder === 1 ? "Ascending" : "Descending";

      url = `${url}&${sortParameter.SortByParameter}=${sortParameter.SortByVal}&${sortParameter.SortOrderParameter}=${order}`;
    }

    // console.log("loadRecordsList url", url);
    try {
      //get data
      const res = await axios.get(url);
      console.log("loadRecordsList res", res.data, res.data.data.items);

      if (res.data) {
        let ogList = value === "2" ? completedTableDataRef.current.map((ele) => ele) : pendingTableDataRef.current.map((ele) => ele);
        await modifyList(res.data.data.items, direction, ogList);
        setTotalRecords(res.data.data.totalItems);

        return res.data.data.items;
      } else {
        return false;
      }
    } catch (err) {
      // console.log("loadRecordsList err", err);
    }
  };

  //maping records for lazy load
  const modifyList = (list, direction, ogList) => {
    console.log("modifyList", list, direction);
    if (list.length > 0) {
      //list has data

      const updList = list
        .map((item) => {
          // console.log(`filtered data ...`, item);
          const _stateList = getStateName(item.stateInfo);

          if (item.juristiction?.includes("Federal")) {
            const categories = _.map(
              item.businessCategory,
              "businessCategoryName"
            ).join(", ");
            // console.log(
            //   `filingMasters ${item.filingMasters} cat...`,
            //   categories
            // );
            return {
              ...item,
              federalCategories: categories,
              stateList: _stateList,
            };
          } else {
            // console.log(
            //   "stateCategories:",
            //   item.filingName,
            //   item.stateInfo,
            //   item.businessCategory
            // );
            const categoriesState = item.businessCategory.filter((ele) =>
              ele.state ? ele.state === item.stateInfo : ele
            );
            // console.log("stateCategories:", item.filingName, categoriesState);
            const categories = categoriesState
              .map((ele) => ele.businessCategoryName)
              .join(", ");

            // console.log(
            //   `filingMasters ${item.filingMasters} cat...`,
            //   categories
            // );
            return {
              ...item,
              stateCategories: categories,
              stateList: _stateList,
            };
          }
        });
      const _jusrisdictions = updList.map((item) =>
        item.juristiction ? item.juristiction : ""
      );
      const _uniqJurisdictions = Array.from(new Set(_jusrisdictions));
      // console.log("@@Unique Jurisdiction:", _uniqJurisdictions);
      setJurisdiction(_uniqJurisdictions);
      // let pendingList = updList.filter(
      //   (ele) => ele.workflowStatus === "Pending"
      // );

      let tableList = value === "1" ? pendingTableDataRef.current : completedTableDataRef.current;
      console.log("modifyList updCustomers", updList, tableList);

      let updFilingMastersList;
      if (direction === "down") {
        //scroll down
        if (tableList.length >= pageSize * 2) {
          //list >= 2 pages

          //remove first pageSize records and add new data
          let unloadList = ogList.slice(pageSize);
          // console.log("modifyList dw unloadList", unloadList);

          //add new data
          updFilingMastersList = [...unloadList, ...updList];
          // console.log("modifyList dw updFilingMastersList", updFilingMastersList);

          // let list = updFilingMastersList.map((ele)=>ele)
          // setClientFiling(updFilingMastersList);
        } else {
          //list < 2 pages

          // add new data to list
          updFilingMastersList = [...ogList, ...updList];
          // console.log("modifyList dw updFilingMastersList", updFilingMastersList);

          // setClientFiling(updFilingMastersList);
        }
      } else if (direction === "up") {
        //scroll up
        if (tableList.length >= pageSize * 2) {
          //list >= 2 pages

          //slice 1 half of list
          let unloadList = ogList.slice(0, pageSize);
          // console.log("modifyList up unloadList", unloadList);

          //add new data
          updFilingMastersList = [...updList, ...unloadList];
          // console.log("modifyList up updFilingMastersList", updFilingMastersList);

          // setClientFiling(updFilingMastersList);
        } else {
          //list < 2 pages

          //slice 1 half of list
          let unloadList = ogList.slice(0, pageSize);
          // console.log("modifyList up unloadList", unloadList);

          //add new data
          updFilingMastersList = [...updList, ...unloadList];
          // console.log("modifyList up updFilingMastersList", updFilingMastersList);

          // setClientFiling(updFilingMastersList);
        }
      }

      if (value === "2") {
        setCompletedTableData(() => updFilingMastersList);
        setFilingMasterApprovalsCompleted(updFilingMastersList)
      } else {
        setInitialData(() => updFilingMastersList);
        setData(() => updFilingMastersList);
        setPendingTableData(() => updFilingMastersList);
        setFilingMasterApprovalsPending(updFilingMastersList)
      }

      setRefreshRecordList(false);
      setLazyLoading(false);
      setIsLoading(false);
      return updFilingMastersList;
    } else {
      //list empty
      // console.log("modifyList empty",list)
      setRefreshRecordList(false);
      setLazyLoading(false);
      setIsLoading(false);
      setFilingMasterApprovalsCompleted([])
      setFilingMasterApprovalsPending([])
      // setClientFiling([]);
      return [];
    }
  };

  const onFilterChange = async (e) => {
    console.log("onFilterChange props", e.filters);
    let filterChange = [];
    const getConstraintValue = (col) => e?.filters?.[col]?.constraints?.[0]?.value;
    const getConstraintMatchMode = (col) => e?.filters?.[col]?.constraints?.[0]?.matchMode;
    const getValueList = (value) =>
      (Array.isArray(value) ? value : [value]).filter(
        (item) => item !== null && item !== undefined && item !== ""
      );
    const pushMultiValueFilters = ({
      name,
      searchType,
      values,
      matchMode,
      transformValue = (value) => value,
    }) => {
      const normalizedValues = getValueList(values);
      normalizedValues.forEach((rawValue, index) => {
        const changeItem = {
          name,
          val: transformValue(rawValue),
        };
        if (index + 1 === normalizedValues.length && searchType) {
          changeItem.searchType = searchType;
          changeItem.searchTypeVal = getSearchType(matchMode);
        }
        filterChange.push(changeItem);
      });
    };

    if (e.filters.global.value !== "" && e.filters.global.value !== null) {
      //global filter
      filterChange.push({
        name: `SearchByFilingName`,
        val: e.filters.global.value,
        searchType: `FilingNameSearchType`,
        searchTypeVal: getSearchType("contains"),
      });
    } else {
      //map filter event
      Object.keys(e.filters).forEach((col) => {
        // console.log("onFilterChange col", col, e.filters[col]);
        if (
          e.filters[col].constraints &&
          e.filters[col].constraints[0].value !== null
        ) {
          if (col === "stateList") {
            pushMultiValueFilters({
              name: `SearchByStateInfo`,
              searchType: `StateInfoSearchType`,
              values: getConstraintValue(col),
              matchMode: getConstraintMatchMode(col),
              transformValue: (value) => getStateCode(value),
            });
          } else if (col === "jsicontactName") {
            filterChange.push({
              name: `SearchByJSIStaff`,
              val: getConstraintValue(col),
              searchType: `JSIStaffSearchType`,
              searchTypeVal: getSearchType(getConstraintMatchMode(col)),
            });
          } else if (col === "federalCategories") {
            pushMultiValueFilters({
              name: `WhoMustFileFederal`,
              searchType: `WhoMustFileFederalSearchType`,
              values: getConstraintValue(col),
              matchMode: getConstraintMatchMode(col),
            });
          } else if (col === "stateCategories") {
            pushMultiValueFilters({
              name: `WhoMustFileInState`,
              searchType: `WhoMustFileInStateSearchType`,
              values: getConstraintValue(col),
              matchMode: getConstraintMatchMode(col),
            });
          } else if (col === "required") {
            const normalizedRequiredValue = normalizeRequiredFilterValue(
              getConstraintValue(col)
            );
            if (normalizedRequiredValue !== null) {
              filterChange.push({
                name: `SearchByRequired`,
                val: normalizedRequiredValue ? "True" : "False",
              });
            }
          } else {
            filterChange.push({
              name: `SearchBy${col}`,
              val: getConstraintValue(col),
              searchType: `${col}SearchType`,
              searchTypeVal: getSearchType(getConstraintMatchMode(col)),
            });
          }
        }
      });
    }
    console.log("onFilterChange filterChange", filterChange);

    //set filter
    handleSetFilterVariable(filterChange);
  };

  const formatFilterDate = (date) => {
    // console.log("formatFilterDate", date);
    let getDate = new Date(date);
    let formatDate = `${getDate.getFullYear()}-${getDate.getMonth() + 1
      }-${getDate.getDate()}`;
    // console.log("formatFilterDate formatDate", getDate.getFullYear(), formatDate);
    return formatDate;
  };

  const getStateCode = (stateName) => {
    // console.log("getStateCode", stateName, states);
    const state = states.find((s) => s.state === stateName);
    return state ? state.code : stateName;
  };

  const matchModeVal = [
    { name: "contains", val: "Contains" },
    { name: "in", val: "Contains" },
    { name: "notContains", val: "NotContains" },
    { name: "equals", val: "EqualTo" },
    { name: "dateIs", val: "DateIs" },
    { name: "dateIsNot", val: "DateIsNot" },
    { name: "dateBefore", val: "DateIsBefore" },
    { name: "dateAfter", val: "DateIsAfter" },
  ];

  const getSearchType = (matchMode) => {
    // console.log("getSearchType props", matchMode);
    return matchModeVal.find((ele) => ele.name === matchMode).val;
  };

  //set filter
  const handleSetFilterVariable = (filterChange) => {
    console.log("handleSetFilterVariable props", filterChange);
    const filterSignature = JSON.stringify(filterChange || []);
    if (lastFilterSignatureRef.current === filterSignature) {
      return;
    }
    lastFilterSignatureRef.current = filterSignature;
    setIsFilterChange(() => filterChange);
    setRecordsInViewSafe(0);
    setIsLoading(true);
    setInitialData([]);
    setData([]);
    setPendingTableData([]);
    setCompletedTableData([]);
  };

  const handleSort = async (e) => {
    console.log("handleSort props", e, e.sortField);
    if (e.sortField !== "") {
      setSortingData(() => ({
        sortBy: e.sortField,
        sortOrder: e.sortOrder,
      }));
      setRecordsInViewSafe(0);
      setIsLoading(true);
      setInitialData([]);
      setData([]);
      setPendingTableData([]);
      setCompletedTableData([]);
    }
  };

  const getSortData = (val) => {
    console.log("getSortData props", val);
    if (val === "federalCategories" || val === "stateCategories") {
      return {
        SortByParameter: "SortBy",
        SortByVal: "BusinessCategory",
        SortOrderParameter: "SortOrder",
      };
    } else {
      return {
        SortByParameter: "SortBy",
        SortByVal: val.charAt(0).toUpperCase() + val.slice(1),
        SortOrderParameter: "SortOrder",
      };
    }
  };

  useEffect(() => {
    // console.log("filter/sort change", isFilterChange, sortingData, lazyLoading );
    //on filter/sort change
    if (!lazyLoading && !refreshRecordList) {
      setLazyLoading(true);
      const sortAndFilterApiCall = async () => {
        let records = await loadRecordsList(0, pageSize, "down");
        setRecordsInViewSafe(1);
        console.log("recordsCheck", records);
        setIsLoading(false);
      };
      sortAndFilterApiCall();
    }
  }, [isFilterChange, sortingData]);

  const refreshRecords = async () => {
    console.log("refreshRecords");

    //Virtual scroll callback
    const vScroll =
      value === "1"
        ? dt.current.getVirtualScroller()
        : dtComp.current.getVirtualScroller();
    let range = vScroll.getRenderedRange();
    console.log("refreshRecords vScroll", vScroll, range);

    let records
    console.log("refreshRecords refreshDetails", refreshDetails);
    if (refreshDetails?.pageInView || refreshDetails?.noOfPages) {
      let first = refreshDetails.pageInView * pageSize
      records = await loadRecordsList(first, first + refreshDetails?.noOfPages * pageSize, "down");
    } else {
      records = await loadRecordsList(0, pageSize, "down");
    }

    if (records) {
      console.log("refreshRecords refreshDetails", refreshDetails);
      if (refreshDetails?.viewport && refreshDetails?.noOfPages) {
        setRecordsInViewSafe((old) => old + refreshDetails?.noOfPages);
      } else {
        setRecordsInViewSafe((old) => old + 1);
      }
      setLazyLoading(false);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    console.log("refreshRecordList,", refreshRecordList, !lazyLoading);
    if (refreshRecordList && !lazyLoading) {
      setLazyLoading(true);
      refreshRecords();
    }
  }, [refreshRecordList]);

  useEffect(() => {
    console.log("Total Records updated:", totalRecords);
  }, [totalRecords]);

  useEffect(() => {
    console.log("recordsInView,", recordsInView);
    recordsInViewRef.current = recordsInView;
  }, [recordsInView]);

  useEffect(() => {
    console.log("pendingTableData,", pendingTableData);
    pendingTableDataRef.current = pendingTableData;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    pendingTableData,
    pendingTableData.length,
    JSON.stringify(pendingTableData),
  ]);

  useEffect(() => {
    completedTableDataRef.current = completedTableData;
  }, [completedTableData]);

  useEffect(() => {
    console.log("filingMasterApprovals,", filingMasterApprovals);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filingMasterApprovals]);

  useEffect(() => {
    console.log("filingMasterApprovalsCompleted,", filingMasterApprovalsCompleted);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filingMasterApprovalsCompleted]);

  useEffect(() => {
    console.log("isLoading", isLoading);
  }, [isLoading]);

  useEffect(() => {
    console.log("lazyLoading", lazyLoading);
  }, [lazyLoading]);

  return (
    <Fragment>
      {isLoading && (
        <CircularProgress
          sx={{ position: 'fixed', top: '50%', left: '50%', zIndex: 9999, color: tableHeaderColor }}
        />
      )}
      <div style={{ display: "flex", alignItems: "flex-start", width: "100%" }}>
        <Grid sx={{ height: "100%", width: isMobile ? "100%" : "93%" }}>
          <ApproveFilingMaster
            show={showFilter}
            dockAt="right"
            drafts={selectedFiling}
            handleClose={closeFilter}
            updateSelectedWorkflow={updateSelectedWorkflow}
          />

          <Grid sx={{ height: "100%" }}>
            <style>{`
  .p-datatable.frozen-filing-approval-pending,
  .p-datatable.frozen-filing-approval-completed {
    border-radius: 8px !important;
    overflow: hidden !important;
    border: none !important;
    box-shadow: none !important;
    background: ${tableBackgroundColor} !important;
  }

  .frozen-filing-approval-pending .p-datatable-wrapper,
  .frozen-filing-approval-completed .p-datatable-wrapper {
    border-radius: 8px !important;
    overflow-x: auto !important;
    overflow-y: auto !important;
    background: ${tableBackgroundColor} !important;
    height: 550px !important;
    max-height: 550px !important;
  }

  .frozen-filing-approval-pending .p-datatable-header,
  .frozen-filing-approval-completed .p-datatable-header {
    background: ${tableBackgroundColor} !important;
    border: none !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  .frozen-filing-approval-pending .p-datatable-table,
  .frozen-filing-approval-completed .p-datatable-table {
    border-radius: 8px !important;
    border-collapse: separate !important;
    border-spacing: 0 !important;
  }

  .frozen-filing-approval-pending .p-selection-column,
  .frozen-filing-approval-completed .p-selection-column {
    text-align: center !important;
  }

  .frozen-filing-approval-pending .p-selection-column .p-checkbox,
  .frozen-filing-approval-completed .p-selection-column .p-checkbox {
    display: flex;
    justify-content: center;
    margin: 0 auto;
  }

  /* HEADER */
  .frozen-filing-approval-pending .p-datatable-thead > tr,
  .frozen-filing-approval-completed .p-datatable-thead > tr {
    background: ${tableHeaderColor} !important;
  }

  .frozen-filing-approval-pending .p-datatable-thead > tr:first-child > th:first-child,
  .frozen-filing-approval-completed .p-datatable-thead > tr:first-child > th:first-child {
    border-top-left-radius: 8px !important;
  }

  .frozen-filing-approval-pending .p-datatable-thead > tr:first-child > th:last-child,
  .frozen-filing-approval-completed .p-datatable-thead > tr:first-child > th:last-child {
    border-top-right-radius: 8px !important;
  }

  .frozen-filing-approval-pending .p-datatable-tbody > tr:last-child > td:first-child,
  .frozen-filing-approval-completed .p-datatable-tbody > tr:last-child > td:first-child {
    border-bottom-left-radius: 8px !important;
  }

  .frozen-filing-approval-pending .p-datatable-tbody > tr:last-child > td:last-child,
  .frozen-filing-approval-completed .p-datatable-tbody > tr:last-child > td:last-child {
    border-bottom-right-radius: 8px !important;
  }

  .frozen-filing-approval-pending .p-datatable-thead > tr > th,
  .frozen-filing-approval-completed .p-datatable-thead > tr > th {
    background: transparent !important;
    color: #ffffff !important;
    font-weight: 600 !important;
    font-size: 13px !important;
    letter-spacing: 0.02em !important;
    padding: 12px 16px !important;
    border-right: 1px solid rgba(255, 255, 255, 0.5) !important;
    border-bottom: none !important;
    text-transform: none !important;
    box-shadow: none !important;
  }

  .frozen-filing-approval-pending .p-datatable-thead > tr > th:last-child,
  .frozen-filing-approval-completed .p-datatable-thead > tr > th:last-child {
    border-right: none !important;
  }

  /* Frozen columns z-index fix and header background */
  .frozen-filing-approval-pending .p-datatable-thead > tr > th.p-frozen-column,
  .frozen-filing-approval-completed .p-datatable-thead > tr > th.p-frozen-column {
    z-index: 2 !important;
    background: ${tableHeaderColor} !important;
    will-change: auto !important;
  }

  .frozen-filing-approval-pending .p-datatable-tbody > tr:nth-child(odd) > td.p-frozen-column,
  .frozen-filing-approval-completed .p-datatable-tbody > tr:nth-child(odd) > td.p-frozen-column {
    z-index: 1 !important;
    background: ${tableBackgroundColor} !important;
    color: #000000 !important;
    will-change: auto !important;
  }

  .frozen-filing-approval-pending .p-datatable-tbody > tr:nth-child(even) > td.p-frozen-column,
  .frozen-filing-approval-completed .p-datatable-tbody > tr:nth-child(even) > td.p-frozen-column {
    z-index: 1 !important;
    background: ${tableBackgroundColor} !important;
    color: #000000 !important;
    will-change: auto !important;
  }

  .frozen-filing-approval-pending .p-sortable-column-icon,
  .frozen-filing-approval-completed .p-sortable-column-icon {
    color: #ffffff !important;
  }

  .frozen-filing-approval-pending .p-datatable-tbody,
  .frozen-filing-approval-completed .p-datatable-tbody {
    background: ${tableBackgroundColor} !important;
  }

  .frozen-filing-approval-pending .p-virtualscroller-content,
  .frozen-filing-approval-completed .p-virtualscroller-content {
    background: ${tableBackgroundColor} !important;
  }

  /* ROWS - Alternating colors with gridlines */
  .frozen-filing-approval-pending .p-datatable-tbody > tr,
  .frozen-filing-approval-completed .p-datatable-tbody > tr {
    height: 45px !important;
  }

  .frozen-filing-approval-pending .p-datatable-tbody > tr:nth-child(odd) > td,
  .frozen-filing-approval-completed .p-datatable-tbody > tr:nth-child(odd) > td {
    background-color: ${tableBackgroundColor} !important;
    padding: 0 12px !important;
    font-size: 15px !important;
    line-height: 1.2 !important;
    color: #000000 !important;
    font-family: Area Normal, Inter, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
    vertical-align: middle !important;
    height: 45px !important;
    min-height: 45px !important;
    max-height: 45px !important;
    box-sizing: border-box !important;
  }

  .frozen-filing-approval-pending .p-datatable-tbody > tr:nth-child(even) > td,
  .frozen-filing-approval-completed .p-datatable-tbody > tr:nth-child(even) > td {
    background-color: ${tableBackgroundColor} !important;
    padding: 0 12px !important;
    font-size: 15px !important;
    line-height: 1.2 !important;
    color: #000000 !important;
    font-family: Area Normal, Inter, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
    vertical-align: middle !important;
    height: 45px !important;
    min-height: 45px !important;
    max-height: 45px !important;
    box-sizing: border-box !important;
  }

  /* FORCE BRAND BORDERS ON ALL CELLS */
  .frozen-filing-approval-pending .p-datatable-tbody > tr > td,
  .frozen-filing-approval-completed .p-datatable-tbody > tr > td {
    border-right: 1px solid ${tableHeaderColor} !important;
    border-bottom: 1px solid ${tableHeaderColor} !important;
    border-left: none !important;
    border-top: none !important;
  }

  .frozen-filing-approval-pending .p-datatable-tbody > tr > td:last-child,
  .frozen-filing-approval-completed .p-datatable-tbody > tr > td:last-child {
    border-right: none !important;
  }

  /* HOVER - Only for clickable cells (Filing Name) */
  .frozen-filing-approval-pending .p-datatable-tbody > tr:not(.p-datatable-row-expansion) > td.filingNameColumn:hover,
  .frozen-filing-approval-completed .p-datatable-tbody > tr:not(.p-datatable-row-expansion) > td.filingNameColumn:hover,
  .frozen-filing-approval-pending .p-datatable-tbody > tr:not(.p-datatable-row-expansion) > td.expandableColumn:hover,
  .frozen-filing-approval-completed .p-datatable-tbody > tr:not(.p-datatable-row-expansion) > td.expandableColumn:hover {
    background-color: color-mix(in srgb, ${tableHeaderColor} 8%, white) !important;
    cursor: pointer !important;
    transition: background-color 0.2s ease;
    border-right: 1px solid ${tableHeaderColor} !important;
    border-bottom: 1px solid ${tableHeaderColor} !important;
  }

  .frozen-filing-approval-pending .p-datatable-tbody > tr:not(.p-datatable-row-expansion) > td.filingNameColumn:hover *,
  .frozen-filing-approval-completed .p-datatable-tbody > tr:not(.p-datatable-row-expansion) > td.filingNameColumn:hover *,
  .frozen-filing-approval-pending .p-datatable-tbody > tr:not(.p-datatable-row-expansion) > td.expandableColumn:hover *,
  .frozen-filing-approval-completed .p-datatable-tbody > tr:not(.p-datatable-row-expansion) > td.expandableColumn:hover * {
    font-weight: 600 !important;
    color: ${tableHeaderColor} !important;
  }

  /* Non-clickable cells - no hover effect */
  .frozen-filing-approval-pending .p-datatable-tbody > tr:not(.p-datatable-row-expansion):not(.p-highlight) > td:not(.filingNameColumn):not(.expandableColumn):hover,
  .frozen-filing-approval-completed .p-datatable-tbody > tr:not(.p-datatable-row-expansion):not(.p-highlight) > td:not(.filingNameColumn):not(.expandableColumn):hover {
    background-color: ${tableBackgroundColor} !important;
    font-weight: 400 !important;
    border-right: 1px solid ${tableHeaderColor} !important;
    border-bottom: 1px solid ${tableHeaderColor} !important;
  }

  .frozen-filing-approval-pending .p-datatable-tbody > tr:not(.p-datatable-row-expansion):not(.p-highlight) > td:not(.filingNameColumn):not(.expandableColumn):not(.indicatorsColumn):hover *,
  .frozen-filing-approval-completed .p-datatable-tbody > tr:not(.p-datatable-row-expansion):not(.p-highlight) > td:not(.filingNameColumn):not(.expandableColumn):not(.indicatorsColumn):hover * {
    font-weight: 400 !important;
    color: #000000 !important;
  }

  /* Indicators column - no hover effect */
  .frozen-filing-approval-pending .p-datatable-tbody > tr:not(.p-datatable-row-expansion) > td.indicatorsColumn:hover,
  .frozen-filing-approval-completed .p-datatable-tbody > tr:not(.p-datatable-row-expansion) > td.indicatorsColumn:hover {
    background-color: inherit !important;
    border-right: 1px solid ${tableHeaderColor} !important;
    border-bottom: 1px solid ${tableHeaderColor} !important;
  }

  /* Expanded parent row - disable hover effect entirely */
  .frozen-filing-approval-pending .p-datatable-tbody > tr.expanded-parent-row > td:hover,
  .frozen-filing-approval-completed .p-datatable-tbody > tr.expanded-parent-row > td:hover {
    background-color: inherit !important;
    cursor: default !important;
    border-right: 1px solid ${tableHeaderColor} !important;
    border-bottom: 1px solid ${tableHeaderColor} !important;
  }

  .frozen-filing-approval-pending .p-datatable-tbody > tr.expanded-parent-row > td:hover *,
  .frozen-filing-approval-completed .p-datatable-tbody > tr.expanded-parent-row > td:hover * {
    color: inherit !important;
    font-weight: inherit !important;
  }

  .frozen-filing-approval-pending .p-datatable-tbody > tr.expanded-parent-row > td.filingNameColumn:hover,
  .frozen-filing-approval-completed .p-datatable-tbody > tr.expanded-parent-row > td.filingNameColumn:hover,
  .frozen-filing-approval-pending .p-datatable-tbody > tr.expanded-parent-row > td.p-frozen-column:hover,
  .frozen-filing-approval-completed .p-datatable-tbody > tr.expanded-parent-row > td.p-frozen-column:hover {
    background-color: inherit !important;
    font-weight: 400 !important;
    cursor: default !important;
  }

  /* Expanded row nested table (Filing Period / DueDate) - header background and no hover color shift */
  .filingPeriodTable .p-datatable-thead > tr {
    background: ${tableHeaderColor} !important;
  }

  .frozen-filing-approval-pending .filingPeriodTable .p-datatable-tbody > tr > td:hover,
  .frozen-filing-approval-completed .filingPeriodTable .p-datatable-tbody > tr > td:hover {
    background-color: inherit !important;
    color: #000000 !important;
    font-weight: 400 !important;
  }

  /* Row expander: prevent global .p-datatable-wrapper height (e.g. 90vh) from inflating nested table */
  .frozen-filing-approval-pending .filingPeriodTable .p-datatable-wrapper,
  .frozen-filing-approval-completed .filingPeriodTable .p-datatable-wrapper {
    height: auto !important;
    max-height: none !important;
    overflow: visible !important;
  }

  /* Keep PrimeReact's row-expander interaction aligned with the active branding color. */
  .frozen-filing-approval-pending .p-row-toggler,
  .frozen-filing-approval-completed .p-row-toggler {
    color: ${tableHeaderColor} !important;
    box-shadow: none !important;
  }

  .frozen-filing-approval-pending .p-row-toggler:hover,
  .frozen-filing-approval-completed .p-row-toggler:hover {
    background-color: color-mix(in srgb, ${tableHeaderColor} 12%, white) !important;
    color: ${tableHeaderColor} !important;
  }

  .frozen-filing-approval-pending .p-row-toggler:focus,
  .frozen-filing-approval-completed .p-row-toggler:focus,
  .frozen-filing-approval-pending .p-row-toggler.p-focus,
  .frozen-filing-approval-completed .p-row-toggler.p-focus {
    background-color: color-mix(in srgb, ${tableHeaderColor} 12%, white) !important;
    box-shadow: 0 0 0 0.2rem color-mix(in srgb, ${tableHeaderColor} 25%, white) !important;
  }

  .frozen-filing-approval-pending .filingPeriodTable .p-datatable-tbody > tr > td:hover *,
  .frozen-filing-approval-completed .filingPeriodTable .p-datatable-tbody > tr > td:hover * {
    color: #000000 !important;
    font-weight: 400 !important;
  }

  .frozen-filing-approval-pending .filingPeriodTable .p-datatable-thead > tr > th:hover,
  .frozen-filing-approval-completed .filingPeriodTable .p-datatable-thead > tr > th:hover,
  .frozen-filing-approval-pending .filingPeriodTable .p-datatable-thead > tr > th:hover *,
  .frozen-filing-approval-completed .filingPeriodTable .p-datatable-thead > tr > th:hover * {
    color: #ffffff !important;
  }

  /* SELECTED ROW */
  .frozen-filing-approval-pending .p-datatable-tbody > tr.p-highlight > td,
  .frozen-filing-approval-completed .p-datatable-tbody > tr.p-highlight > td {
    background-color: color-mix(in srgb, ${tableHeaderColor} 14%, white) !important;
  }

  /* PrimeReact frozen columns keep their own background; ensure selection highlight applies there too. */
  .frozen-filing-approval-pending .p-datatable-tbody > tr.p-highlight > td.p-frozen-column,
  .frozen-filing-approval-completed .p-datatable-tbody > tr.p-highlight > td.p-frozen-column {
    background-color: color-mix(in srgb, ${tableHeaderColor} 14%, white) !important;
  }

  .p-checkbox .p-checkbox-box.p-highlight {
    background: ${tableHeaderColor} !important;
    border-color: ${tableHeaderColor} !important;
  }

  .frozen-filing-approval-pending .p-datatable-loading-icon,
  .frozen-filing-approval-completed .p-datatable-loading-icon {
    color: ${tableHeaderColor} !important;
  }

  .frozen-filing-approval-pending .p-datatable-loading-icon svg,
  .frozen-filing-approval-completed .p-datatable-loading-icon svg {
    stroke: ${tableHeaderColor} !important;
  }

  .filing-master-approval-overlay-panel .p-overlaypanel-close,
  .filing-master-approval-overlay-panel .p-overlaypanel-close:hover {
    background: ${tableHeaderColor} !important;
    border-color: ${tableHeaderColor} !important;
  }

  .filing-master-approval-overlay-panel .p-overlaypanel-close .p-overlaypanel-close-icon,
  .filing-master-approval-overlay-panel .p-overlaypanel-close .pi,
  .filing-master-approval-overlay-panel .p-overlaypanel-close svg {
    color: #ffffff !important;
    fill: #ffffff !important;
  }

  .frozen-filing-approval-pending .p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box:hover,
  .frozen-filing-approval-completed .p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box:hover {
    border-color: ${tableHeaderColor} !important;
  }

  .frozen-filing-approval-pending .p-checkbox .p-checkbox-box.p-focus,
  .frozen-filing-approval-completed .p-checkbox .p-checkbox-box.p-focus,
  .frozen-filing-approval-pending .p-checkbox.p-focus .p-checkbox-box,
  .frozen-filing-approval-completed .p-checkbox.p-focus .p-checkbox-box {
    border-color: ${tableHeaderColor} !important;
    box-shadow: 0 0 0 0.2rem color-mix(in srgb, ${tableHeaderColor} 25%, white) !important;
  }

  /* SCROLLBAR */
  .p-datatable-wrapper::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  .p-datatable-wrapper::-webkit-scrollbar-thumb {
    background: #C0BEC2;
    border-radius: 10px;
  }

  .p-datatable-wrapper::-webkit-scrollbar-thumb:hover {
    background: ${tableHeaderColor};
  }

  ${value === "1"
                ? `
  .MuiMenuItem-root[data-value="workflowStatus"] {
    display: none !important;
  }
`
                : `
  .MuiMenuItem-root[data-value="approverName"] {
    display: none !important;
  }
`}
`}</style>
            <div
              className="card masterFilingApproval"
              style={{
                maxWidth: "90vw",
                padding: "1rem",
                margin: "1rem",
                background: containerBackgroundColor,
                borderRadius: "8px",
                overflow: "visible",
                border: "none",
              }}
            >
              <TabContext value={value}>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                  <TabList onChange={handleTabChange}>
                    <Tab label="Pending" value="1" disabled={isLoading} />
                    <Tab label="Completed" value="2" disabled={isLoading} />
                  </TabList>
                </Box>
                <TabPanel value="1">
                  <DataTable
                    ref={dt}
                    key="pending"
                    className="frozen-filing-approval-pending"
                    scrollable
                    resizableColumns
                    loading={isLoading || lazyLoading}
                    showGridlines
                    value={filingMasterApprovals}
                    selection={selectedFiling}
                    onSelectionChange={(e) => setSelectedFiling(e.value)}
                    dataKey="workflowId"
                    style={{ minHeight: "50vh" }}
                    onRowSelect={onRowSelect}
                    onRowToggle={(e) => rowExpand(e)}
                    rowExpansionTemplate={rowExpansionTemplate}
                    expandedRows={expandedRows}
                    rowClassName={(rowData) =>
                      isExpandedParentRow(rowData) ? "expanded-parent-row" : ""
                    }
                    // paginator={!viewAll}
                    // rows={viewAll ? clients.length : 10}
                    // rowsPerPageOptions={[5, 10, 25, 50]}
                    filters={filters}
                    filterMode="multiple"
                    globalFilterFields={["filingName"]}
                    header={header}
                    virtualScrollerOptions={{
                      // lazy: true,
                      onScroll: loadDataLazy,
                      itemSize: 45,
                      delay: 0,
                      scrollHeight: "550px",
                      appendOnly: true,
                      // showLoader: true,
                      // loading: lazyLoading,
                      // loadingTemplate,
                    }}
                    scrollHeight="550px"
                    onFilter={(e) => onFilterChange(e)}
                    sortField={sortingData.sortBy}
                    sortOrder={sortingData.sortOrder}
                    onSort={(e) => handleSort(e)}
                  >
                    <Column expander={true} style={{ width: "5rem" }} />
                    <Column
                      selectionMode="multiple"
                      headerStyle={{ width: "3rem" }}
                    >
                      Select
                    </Column>
                    <Column
                      headerStyle={{ width: "3rem" }}
                      header="Indicators"
                      className="indicatorsColumn"
                      body={(rowData) => (
                        <>
                          <Stack direction="row" spacing={0.5} alignItems="center">
                            <CustomCommentButton rowData={rowData} />
                            <FilingAttachmentButton rowData={rowData} />
                          </Stack>
                        </>
                      )}
                    ></Column>
                    <Column
                      field="approverName"
                      header="Approver Name"
                      sortable
                      frozen
                      style={{ minWidth: "12rem" }}
                    ></Column>
                    <Column
                      field="filingName"
                      header="Filing Name"
                      sortable
                      frozen
                      className="filingNameColumn"
                      style={{ minWidth: "12rem", maxWidth: "25rem" }}
                      body={(rowData) => cellListDisplayName(rowData)}
                    ></Column>
                    {/* <Column
                   field='filingDescription'
                   header='Filing Description'
                   sortable
                   filter
                   filterPlaceholder='Search by Description'
                   style={{ minWidth: "15rem" }}
                 ></Column> */}
                    <Column
                      field="recentDate"
                      header="Time Stamp"
                      sortable
                      style={{ minWidth: "15rem" }}
                      frozen={enableForzen}

                      body={displayTimeStamp}
                    ></Column>
                    <Column
                      field="filingFrequency"
                      header="Filing Frequency"
                      style={{ minWidth: "15rem" }}
                    ></Column>

                    {/* <Column
                   field='dueDayofFrequency'
                   header='Due Date Offset'
                   filter
                   filterPlaceholder='Search by Frequency'
                   style={{ minWidth: "15rem" }}
                 ></Column> */}
                    <Column
                      field="stateList"
                      header="State"
                      style={{ minWidth: "12rem" }}
                      className="column-small"
                    ></Column>
                    <Column
                      field="ruleInfo"
                      header="Rule Info"
                      style={{ minWidth: "15rem", maxWidth: "15rem" }}
                      body={(rowData) => cellListDisplayRuleInfo(rowData)}
                    ></Column>
                    <Column
                      field="required"
                      header="Required"
                      style={{ minWidth: "13rem" }}
                      className="column-small"
                    ></Column>

                    <Column
                      field="federalCategories"
                      header="Who Must File Federal"
                      className="expandableColumn"
                      body={(rowData) =>
                        CellListDisplayFederal(rowData, "federalCategories")
                      }
                      style={{ minWidth: "20rem", maxWidth: "20rem" }}
                    ></Column>
                    <Column
                      field="stateCategories"
                      header="Who Must File in State"
                      className="expandableColumn"
                      body={(rowData) =>
                        CellListDisplayFederal(rowData, "stateCategories")
                      }
                      style={{ minWidth: "20rem", maxWidth: "20rem" }}
                    ></Column>
                    {/* <Column
                   field='jsidept'
                   header='JSI Dept'
                   filter
                   filterPlaceholder='Search by dept'
                   style={{ minWidth: "15rem" }}
                 ></Column> */}
                    <Column
                      field="jsicontactName"
                      header="JSI Staff"
                      style={{ minWidth: "13rem" }}
                    ></Column>
                    {/* <Column
                   field='jsicontactEmail'
                   header='JSI Contact Email'
                   filter
                   filterPlaceholder='Search by contactEmail'
                   style={{ minWidth: "15rem" }}
                 ></Column> */}
                    <Column
                      field="juristiction"
                      header="Jurisdiction"
                      sortable
                      style={{ minWidth: "14rem" }}
                    ></Column>
                    <Column
                      field="notes"
                      header="Notes"
                      style={{ minWidth: "21rem", maxWidth: "21rem" }}
                      body={(rowData) => cellListDisplayNotes(rowData)}
                    ></Column>
                  </DataTable>
                </TabPanel>
                <TabPanel value="2">
                  <DataTable
                    ref={dtComp}
                    key="completed"
                    scrollable
                    className="frozen-filing-approval-completed"
                    resizableColumns
                    loading={isLoading || lazyLoading}
                    showGridlines
                    value={filingMasterApprovalsCompleted}
                    selection={selectedFiling}
                    onSelectionChange={(e) => setSelectedFiling(e.value)}
                    dataKey="workflowId"
                    style={{ minHeight: "50vh" }}
                    onRowSelect={onRowSelect}
                    onRowToggle={(e) => rowExpand(e)}
                    rowExpansionTemplate={rowExpansionTemplate}
                    expandedRows={expandedRows}
                    rowClassName={(rowData) =>
                      isExpandedParentRow(rowData) ? "expanded-parent-row" : ""
                    }
                    // paginator={!viewAll}
                    // rows={viewAll ? clients.length : 10}
                    // rowsPerPageOptions={[5, 10, 25, 50]}
                    filters={filters}
                    filterMode="multiple"
                    globalFilterFields={["filingName"]}
                    header={completedHeader}
                    virtualScrollerOptions={{
                      // lazy: true,
                      onScroll: loadDataLazy,
                      itemSize: 45,
                      delay: 0,
                      scrollHeight: "550px",
                      appendOnly: true,
                      // showLoader: true,
                      // loading: lazyLoading,
                      // loadingTemplate,
                    }}
                    scrollHeight="550px"
                    onFilter={(e) => onFilterChange(e)}
                    sortField={sortingData.sortBy}
                    sortOrder={sortingData.sortOrder}
                    onSort={(e) => handleSort(e)}
                  >
                    <Column expander={true} style={{ width: "5rem" }} />
                    <Column
                      selectionMode="multiple"
                      headerStyle={{ width: "3rem" }}
                    >
                      Select
                    </Column>
                    <Column
                      headerStyle={{ width: "3rem" }}
                      header="Indicators"
                      className="indicatorsColumn"
                      body={(rowData) => (
                        <>
                          <Stack direction="row" spacing={0.5} alignItems="center">
                            <CustomCommentButton rowData={rowData} />
                            <FilingAttachmentButton rowData={rowData} />
                          </Stack>
                        </>
                      )}
                    ></Column>
                    <Column
                      field="filingName"
                      header="Filing Name"
                      sortable
                      frozen
                      className="filingNameColumn"
                      style={{ minWidth: "12rem", maxWidth: "25rem" }}
                      body={(rowData) => cellListDisplayName(rowData)}
                    ></Column>
                    {/* <Column
                   field='filingDescription'
                   header='Filing Description'
                   sortable
                   filter
                   filterPlaceholder='Search by Description'
                   style={{ minWidth: "15rem" }}
                 ></Column> */}
                    <Column
                      field="filingFrequency"
                      header="Filing Frequency"
                      frozen={enableForzen}
                      style={{ minWidth: "12rem" }}
                    ></Column>
                    {/* <Column
                   field='dueDayofFrequency'
                   header='Due Date Offset'
                   filter
                   filterPlaceholder='Search by Frequency'
                   style={{ minWidth: "15rem" }}
                 ></Column> */}
                    <Column
                      field="recentDate"
                      header="Time Stamp"
                      sortable
                      style={{ minWidth: "15rem" }}
                      frozen={enableForzen}
                      body={displayTimeStamp}
                    ></Column>
                    <Column
                      field="stateList"
                      header="State"
                      style={{ minWidth: "11rem" }}
                      className="column-small"
                    ></Column>
                    <Column
                      field="ruleInfo"
                      header="Rule Info"
                      style={{ minWidth: "15rem", maxWidth: "15rem" }}
                      body={(rowData) => cellListDisplayRuleInfo(rowData)}
                    ></Column>
                    <Column
                      field="required"
                      header="Required"
                      style={{ minWidth: "13rem" }}
                      className="column-small"
                    ></Column>
                    <Column
                      field="workflowStatus"
                      header="Status"
                      style={{ minWidth: "15rem" }}
                    ></Column>
                    <Column
                      field="federalCategories"
                      header="Who Must File Federal"
                      className="expandableColumn"
                      body={(rowData) =>
                        CellListDisplayFederal(rowData, "federalCategories")
                      }
                      style={{ minWidth: "20rem", maxWidth: "20rem" }}
                    ></Column>
                    <Column
                      field="stateCategories"
                      header="Who Must File in State"
                      className="expandableColumn"
                      body={(rowData) =>
                        CellListDisplayFederal(rowData, "stateCategories")
                      }
                      style={{ minWidth: "20rem", maxWidth: "20rem" }}
                    ></Column>
                    {/* <Column
                   field='jsidept'
                   header='JSI Dept'
                   filter
                   filterPlaceholder='Search by dept'
                   style={{ minWidth: "15rem" }}
                 ></Column> */}
                    <Column
                      field="jsicontactName"
                      header="JSI Staff"
                      style={{ minWidth: "15rem" }}
                    ></Column>
                    {/* <Column
                   field='jsicontactEmail'
                   header='JSI Contact Email'
                   filter
                   filterPlaceholder='Search by contactEmail'
                   style={{ minWidth: "15rem" }}
                 ></Column> */}
                    <Column
                      field="juristiction"
                      header="Jurisdiction"
                      sortable
                      style={{ minWidth: "14rem" }}
                    ></Column>
                    <Column
                      field="notes"
                      header="Notes"
                      style={{ minWidth: "21rem", maxWidth: "21rem" }}
                      body={(rowData) => cellListDisplayNotes(rowData)}
                    ></Column>
                  </DataTable>
                </TabPanel>
              </TabContext>
            </div>
          </Grid>
        </Grid>
        <CustomDialog
          header="Selection Required"
          visible={showAlert}
          onHide={closeAlert}
          icon="⚠️"
        >
          {alertMessage}
        </CustomDialog>
        {
          <FilingMasterWorkflowComments
            show={showComments}
            dockAt="right"
            workflow={selectedFiling[0]}
            rowData={selectedRowData}
            comments={comments}
            handleClose={closeComments}
            refreshList={handleRefreshList}
            value={value}
          />
        }
        {
          <FilingMasterReferenceDocument
            show={showAttachments}
            dockAt="right"
            filing={selectedFiling[0]}
            attachments={attachments}
            handleClose={closeAttachments}
          />
        }
        {
          <FilingMasterApprovalHistory
            show={showHistory}
            dockAt="right"
            tracker={selectedFiling[0]}
            activityHistory={activityHistory}
            commentActivityHistory={commentActivityHistory}
            handleClose={closeHistory}
          />
        }
        <ClientTableFilter
          anchorEl={filterAnchorEl}
          onClose={handleFilterClose}
          onApply={handleFilterApply}
          onClear={handleFilterClear}
          clients={value === "1" ? filingMasterApprovals : filingMasterApprovalsCompleted}
          categoriesLookup={approvalCategoryLookup}
          programList={[]}
          stateList={stateArray}
          tracknowlicenseTypes={[]}
          postawardlicenseTypes={[]}
          roleType={roleType}
          filingMasterMode={true}
          requiredOnlyIs={true}
          jurisdictionLookup={["Federal", "State", "Both"]}
          filterOptionsByColumn={{
            juristiction: [
              { value: FilterMatchMode.CONTAINS, label: "Is" },
            ],
          }}
        />
        <Grid
          sx={{
            display: isMobile ? "none" : "block",
            height: "100%",
            width: "5%",
            position: "sticky",
            top: 10,
            alignSelf: "flex-start",
            zIndex: 2,
          }}
        >
          <div
            style={{
              height: "100%",
              background: "transparent",
              marginTop: "0",
            }}
          >
            <Item
              sx={{
                height: "100%",
                background: "transparent",
                boxShadow: "none",
                borderRadius: "50px",
                overflow: "visible",
              }}
            >
              <ApproveToolbox
                isLoading={isLoading}
                addComment={addComment}
                approveDraft={approveDraft}
                isDisabled={isDisabled}
                displayAttachments={displayAttachments}
                displayHistory={displayHistory}
              />
            </Item>
          </div>
        </Grid>
      </div>
    </Fragment>
  );
};
export default ApprovalList;
